// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studiomediamatrix/v1/service.proto (package creativefabrica.studiomediamatrix.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_creativefabrica_common_v1_types } from "@repo/rpc-types-creativefabrica-common-v1";
import type { CatalogModel, CatalogModelJson } from "@repo/rpc-types-creativefabrica-preset-v1/ai_provider";
import { file_creativefabrica_preset_v1_ai_provider } from "@repo/rpc-types-creativefabrica-preset-v1/ai_provider";
import type { ActionType, ActionTypeJson, AIMockupGeneratorTemplate, AIMockupGeneratorTemplateJson, AIPhotoStyle, AIPhotoStyleContent, AIPhotoStyleContentJson, AIPhotoStyleJson, AISVGGeneratorContent, AISVGGeneratorContentJson, BrandedMedia, BrandedMediaJson, BrandedMediaPlatform, BrandedMediaPlatformJson, BrandedMediaType, BrandedMediaTypeJson, CameraAngleContent, CameraAngleContentJson, CollageMakerContent, CollageMakerContentJson, ColorDescription, ColorDescriptionJson, ColoringPageMakerContent, ColoringPageMakerContentJson, DoodlePetContent, DoodlePetContentJson, Download, DownloadJson, EtsyCoachContent, EtsyCoachContentJson, Image, ImageContent, ImageContentJson, ImageGeneratorModel, ImageGeneratorModelJson, ImageJson, ImportedImageSource, ImportedImageSourceJson, InpaintContent, InpaintContentJson, InpaintScribbleColor, InpaintScribbleColorJson, InputMedia, InputMediaJson, InternalRequestImageContent, InternalRequestImageContentJson, Iteration, IterationJson, MarketplaceEditorContent, MarketplaceEditorContentJson, MediaItem, MediaItemJson, MusicGeneratorSection, MusicGeneratorSectionJson, MusicGeneratorSongSettings, MusicGeneratorSongSettingsJson, Notice, NoticeActionType, NoticeActionTypeJson, NoticeJson, PromptContent, PromptContentJson, PromptMusicGeneratorContent, PromptMusicGeneratorContentJson, PromptSoundGeneratorContent, PromptSoundGeneratorContentJson, PromptSpeechGeneratorContent, PromptSpeechGeneratorContentJson, PromptToVideoGeneratorContent, PromptToVideoGeneratorContentJson, PromptWithImagesContent, PromptWithImagesContentJson, ReplaceableObject, ReplaceableObjectJson, ServiceType, ServiceTypeJson, Session, SessionJson, SessionRequestAdBannerResizerContent, SessionRequestAdBannerResizerContentJson, SessionRequestAdBannerResizerSizesContent, SessionRequestAdBannerResizerSizesContentJson, SessionRequestAIMockupGeneratorContent, SessionRequestAIMockupGeneratorContentJson, SessionRequestAIPhotoStyleContent, SessionRequestAIPhotoStyleContentJson, SessionRequestAISVGGeneratorContent, SessionRequestAISVGGeneratorContentJson, SessionRequestCameraAngleContent, SessionRequestCameraAngleContentJson, SessionRequestCollageMakerContent, SessionRequestCollageMakerContentJson, SessionRequestColoringPageMakerContent, SessionRequestColoringPageMakerContentJson, SessionRequestDoodlePetContent, SessionRequestDoodlePetContentJson, SessionRequestEtsyCoachContent, SessionRequestEtsyCoachContentJson, SessionRequestImageContent, SessionRequestImageContentJson, SessionRequestInpaintContent, SessionRequestInpaintContentJson, SessionRequestLogoGeneratorContent, SessionRequestLogoGeneratorContentJson, SessionRequestMarketplaceEditorContent, SessionRequestMarketplaceEditorContentJson, SessionRequestPromptContent, SessionRequestPromptContentJson, SessionRequestPromptMusicGeneratorContent, SessionRequestPromptMusicGeneratorContentJson, SessionRequestPromptMusicLyricsStructuredContent, SessionRequestPromptMusicLyricsStructuredContentJson, SessionRequestPromptSoundGeneratorContent, SessionRequestPromptSoundGeneratorContentJson, SessionRequestPromptSpeechGeneratorContent, SessionRequestPromptSpeechGeneratorContentJson, SessionRequestPromptToVideoGeneratorContent, SessionRequestPromptToVideoGeneratorContentJson, SessionRequestPromptWithImagesContent, SessionRequestPromptWithImagesContentJson, SessionRequestSourceFromImageContent, SessionRequestSourceFromImageContentJson, SessionRequestSplatContent, SessionRequestSplatContentJson, SessionRequestTextCADContent, SessionRequestTextCADContentJson, SessionRequestTextMeshContent, SessionRequestTextMeshContentJson, SessionRequestToonFamilyContent, SessionRequestToonFamilyContentJson, SessionRequestVideoCutoutsContent, SessionRequestVideoCutoutsContentJson, SessionRequestVideoEditorContent, SessionRequestVideoEditorContentJson, SessionRequestVideoEditorPromptContent, SessionRequestVideoEditorPromptContentJson, SessionRequestVideoTemplateContent, SessionRequestVideoTemplateContentJson, SessionRequestVideoUpscalerContent, SessionRequestVideoUpscalerContentJson, SessionRequestWeddingInviteContent, SessionRequestWeddingInviteContentJson, SessionRequestYouTubeThumbnailGeneratorContent, SessionRequestYouTubeThumbnailGeneratorContentJson, SessionVisibility, SessionVisibilityJson, ShareActionType, ShareActionTypeJson, Source, SourceFromImageContent, SourceFromImageContentJson, SourceJson, SpeechGeneratorConfig, SpeechGeneratorConfigJson, SpeechVoiceFilterOptions, SpeechVoiceFilterOptionsJson, SplatContent, SplatContentJson, TextCADContent, TextCADContentJson, ToolType, ToolTypeJson, ToonFamilyContent, ToonFamilyContentJson, VideoEditorContent, VideoEditorContentJson, VideoEditorModel, VideoEditorModelJson, VideoGeneratorModel, VideoGeneratorModelJson, VideoGeneratorTemplate, VideoGeneratorTemplateJson, VideoUpscalerByteplusEnhanceConfig, VideoUpscalerByteplusEnhanceConfigJson, VideoUpscalerContent, VideoUpscalerContentJson, VideoUpscalerFluxVideoUpscaleConfig, VideoUpscalerFluxVideoUpscaleConfigJson, VideoUpscalerModel, VideoUpscalerModelJson, Voice, VoiceJson, WeddingInviteContent, WeddingInviteContentJson, YouTubeThumbnailGeneratorContent, YouTubeThumbnailGeneratorContentJson, YouTubeThumbnailTemplate, YouTubeThumbnailTemplateJson } from "./types_pb";
import { file_creativefabrica_studiomediamatrix_v1_types } from "./types_pb";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studiomediamatrix/v1/service.proto.
 */
export const file_creativefabrica_studiomediamatrix_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_common_v1_types, file_creativefabrica_preset_v1_ai_provider, file_creativefabrica_studiomediamatrix_v1_types, file_google_api_annotations]);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesRequest
 */
export type ListSpeechVoicesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListSpeechVoicesRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter filter = 1;
   */
  filter?: SpeechVoiceFilter | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesRequest
 */
export type ListSpeechVoicesRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter filter = 1;
   */
  filter?: SpeechVoiceFilterJson;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesRequest.
 * Use `create(ListSpeechVoicesRequestSchema)` to create a new message.
 */
export const ListSpeechVoicesRequestSchema: GenMessage<ListSpeechVoicesRequest, {jsonType: ListSpeechVoicesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesResponse
 */
export type ListSpeechVoicesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListSpeechVoicesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Voice voices = 1;
   */
  voices: Voice[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesResponse
 */
export type ListSpeechVoicesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Voice voices = 1;
   */
  voices?: VoiceJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListSpeechVoicesResponse.
 * Use `create(ListSpeechVoicesResponseSchema)` to create a new message.
 */
export const ListSpeechVoicesResponseSchema: GenMessage<ListSpeechVoicesResponse, {jsonType: ListSpeechVoicesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 1);

/**
 * SpeechVoiceFilter narrows a voice listing. All set fields are AND'd
 * together. The query matches case-insensitively against the voice name.
 * Accent is a dependent filter scoped to a language: it only applies when
 * language is also set, and is matched against the accents the voice is
 * verified for in that language.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter
 */
export type SpeechVoiceFilter = Message<"creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter"> & {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string | undefined;

  /**
   * @generated from field: optional string gender = 2;
   */
  gender?: string | undefined;

  /**
   * @generated from field: optional string age = 3;
   */
  age?: string | undefined;

  /**
   * @generated from field: optional string language = 4;
   */
  language?: string | undefined;

  /**
   * @generated from field: optional string accent = 5;
   */
  accent?: string | undefined;

  /**
   * @generated from field: optional string use_case = 6;
   */
  useCase?: string | undefined;
};

/**
 * SpeechVoiceFilter narrows a voice listing. All set fields are AND'd
 * together. The query matches case-insensitively against the voice name.
 * Accent is a dependent filter scoped to a language: it only applies when
 * language is also set, and is matched against the accents the voice is
 * verified for in that language.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter
 */
export type SpeechVoiceFilterJson = {
  /**
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * @generated from field: optional string gender = 2;
   */
  gender?: string;

  /**
   * @generated from field: optional string age = 3;
   */
  age?: string;

  /**
   * @generated from field: optional string language = 4;
   */
  language?: string;

  /**
   * @generated from field: optional string accent = 5;
   */
  accent?: string;

  /**
   * @generated from field: optional string use_case = 6;
   */
  useCase?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SpeechVoiceFilter.
 * Use `create(SpeechVoiceFilterSchema)` to create a new message.
 */
export const SpeechVoiceFilterSchema: GenMessage<SpeechVoiceFilter, {jsonType: SpeechVoiceFilterJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 2);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsRequest
 */
export type GetSpeechVoiceFilterOptionsRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsRequest"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsRequest
 */
export type GetSpeechVoiceFilterOptionsRequestJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsRequest.
 * Use `create(GetSpeechVoiceFilterOptionsRequestSchema)` to create a new message.
 */
export const GetSpeechVoiceFilterOptionsRequestSchema: GenMessage<GetSpeechVoiceFilterOptionsRequest, {jsonType: GetSpeechVoiceFilterOptionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 3);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsResponse
 */
export type GetSpeechVoiceFilterOptionsResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions filter_options = 1;
   */
  filterOptions?: SpeechVoiceFilterOptions | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsResponse
 */
export type GetSpeechVoiceFilterOptionsResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechVoiceFilterOptions filter_options = 1;
   */
  filterOptions?: SpeechVoiceFilterOptionsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSpeechVoiceFilterOptionsResponse.
 * Use `create(GetSpeechVoiceFilterOptionsResponseSchema)` to create a new message.
 */
export const GetSpeechVoiceFilterOptionsResponseSchema: GenMessage<GetSpeechVoiceFilterOptionsResponse, {jsonType: GetSpeechVoiceFilterOptionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 4);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesRequest
 */
export type ListMockupGeneratorTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesRequest
 */
export type ListMockupGeneratorTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesRequest.
 * Use `create(ListMockupGeneratorTemplatesRequestSchema)` to create a new message.
 */
export const ListMockupGeneratorTemplatesRequestSchema: GenMessage<ListMockupGeneratorTemplatesRequest, {jsonType: ListMockupGeneratorTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 5);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesResponse
 */
export type ListMockupGeneratorTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate templates = 1;
   */
  templates: AIMockupGeneratorTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesResponse
 */
export type ListMockupGeneratorTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate templates = 1;
   */
  templates?: AIMockupGeneratorTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMockupGeneratorTemplatesResponse.
 * Use `create(ListMockupGeneratorTemplatesResponseSchema)` to create a new message.
 */
export const ListMockupGeneratorTemplatesResponseSchema: GenMessage<ListMockupGeneratorTemplatesResponse, {jsonType: ListMockupGeneratorTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 6);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesRequest
 */
export type ListVideoGeneratorTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesRequest
 */
export type ListVideoGeneratorTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesRequest.
 * Use `create(ListVideoGeneratorTemplatesRequestSchema)` to create a new message.
 */
export const ListVideoGeneratorTemplatesRequestSchema: GenMessage<ListVideoGeneratorTemplatesRequest, {jsonType: ListVideoGeneratorTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 7);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesResponse
 */
export type ListVideoGeneratorTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate templates = 1;
   */
  templates: VideoGeneratorTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesResponse
 */
export type ListVideoGeneratorTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate templates = 1;
   */
  templates?: VideoGeneratorTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListVideoGeneratorTemplatesResponse.
 * Use `create(ListVideoGeneratorTemplatesResponseSchema)` to create a new message.
 */
export const ListVideoGeneratorTemplatesResponseSchema: GenMessage<ListVideoGeneratorTemplatesResponse, {jsonType: ListVideoGeneratorTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 8);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateRequest
 */
export type GetVideoGeneratorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateRequest
 */
export type GetVideoGeneratorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateRequest.
 * Use `create(GetVideoGeneratorTemplateRequestSchema)` to create a new message.
 */
export const GetVideoGeneratorTemplateRequestSchema: GenMessage<GetVideoGeneratorTemplateRequest, {jsonType: GetVideoGeneratorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 9);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateResponse
 */
export type GetVideoGeneratorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate template = 1;
   */
  template?: VideoGeneratorTemplate | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateResponse
 */
export type GetVideoGeneratorTemplateResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorTemplate template = 1;
   */
  template?: VideoGeneratorTemplateJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetVideoGeneratorTemplateResponse.
 * Use `create(GetVideoGeneratorTemplateResponseSchema)` to create a new message.
 */
export const GetVideoGeneratorTemplateResponseSchema: GenMessage<GetVideoGeneratorTemplateResponse, {jsonType: GetVideoGeneratorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 10);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateRequest
 */
export type GetMockupGeneratorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateRequest
 */
export type GetMockupGeneratorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateRequest.
 * Use `create(GetMockupGeneratorTemplateRequestSchema)` to create a new message.
 */
export const GetMockupGeneratorTemplateRequestSchema: GenMessage<GetMockupGeneratorTemplateRequest, {jsonType: GetMockupGeneratorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 11);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateResponse
 */
export type GetMockupGeneratorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate template = 1;
   */
  template?: AIMockupGeneratorTemplate | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateResponse
 */
export type GetMockupGeneratorTemplateResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate template = 1;
   */
  template?: AIMockupGeneratorTemplateJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetMockupGeneratorTemplateResponse.
 * Use `create(GetMockupGeneratorTemplateResponseSchema)` to create a new message.
 */
export const GetMockupGeneratorTemplateResponseSchema: GenMessage<GetMockupGeneratorTemplateResponse, {jsonType: GetMockupGeneratorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 12);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateRequest
 */
export type FavoriteMockupGeneratorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateRequest
 */
export type FavoriteMockupGeneratorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateRequest.
 * Use `create(FavoriteMockupGeneratorTemplateRequestSchema)` to create a new message.
 */
export const FavoriteMockupGeneratorTemplateRequestSchema: GenMessage<FavoriteMockupGeneratorTemplateRequest, {jsonType: FavoriteMockupGeneratorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 13);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateResponse
 */
export type FavoriteMockupGeneratorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateResponse
 */
export type FavoriteMockupGeneratorTemplateResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteMockupGeneratorTemplateResponse.
 * Use `create(FavoriteMockupGeneratorTemplateResponseSchema)` to create a new message.
 */
export const FavoriteMockupGeneratorTemplateResponseSchema: GenMessage<FavoriteMockupGeneratorTemplateResponse, {jsonType: FavoriteMockupGeneratorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 14);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateRequest
 */
export type UnfavoriteMockupGeneratorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateRequest
 */
export type UnfavoriteMockupGeneratorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateRequest.
 * Use `create(UnfavoriteMockupGeneratorTemplateRequestSchema)` to create a new message.
 */
export const UnfavoriteMockupGeneratorTemplateRequestSchema: GenMessage<UnfavoriteMockupGeneratorTemplateRequest, {jsonType: UnfavoriteMockupGeneratorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 15);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateResponse
 */
export type UnfavoriteMockupGeneratorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateResponse
 */
export type UnfavoriteMockupGeneratorTemplateResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteMockupGeneratorTemplateResponse.
 * Use `create(UnfavoriteMockupGeneratorTemplateResponseSchema)` to create a new message.
 */
export const UnfavoriteMockupGeneratorTemplateResponseSchema: GenMessage<UnfavoriteMockupGeneratorTemplateResponse, {jsonType: UnfavoriteMockupGeneratorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 16);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesRequest
 */
export type ListFavoriteMockupGeneratorTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesRequest
 */
export type ListFavoriteMockupGeneratorTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesRequest.
 * Use `create(ListFavoriteMockupGeneratorTemplatesRequestSchema)` to create a new message.
 */
export const ListFavoriteMockupGeneratorTemplatesRequestSchema: GenMessage<ListFavoriteMockupGeneratorTemplatesRequest, {jsonType: ListFavoriteMockupGeneratorTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 17);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesResponse
 */
export type ListFavoriteMockupGeneratorTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate templates = 1;
   */
  templates: AIMockupGeneratorTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesResponse
 */
export type ListFavoriteMockupGeneratorTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplate templates = 1;
   */
  templates?: AIMockupGeneratorTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteMockupGeneratorTemplatesResponse.
 * Use `create(ListFavoriteMockupGeneratorTemplatesResponseSchema)` to create a new message.
 */
export const ListFavoriteMockupGeneratorTemplatesResponseSchema: GenMessage<ListFavoriteMockupGeneratorTemplatesResponse, {jsonType: ListFavoriteMockupGeneratorTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 18);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest
 */
export type CreateMockupCreatorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 3;
   */
  replaceableObjects: ReplaceableObject[];

  /**
   * Provide reference_image to mint a presigned upload URL the caller will
   * then PUT the bytes to. Mutually exclusive with reference_image_url.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent reference_image = 4;
   */
  referenceImage?: CreateMockupCreatorTemplateRequest_RequestImageContent | undefined;

  /**
   * Provide reference_image_url to skip uploading and persist an existing
   * public URL as the template's reference image. Mutually exclusive with
   * reference_image.
   *
   * @generated from field: string reference_image_url = 5;
   */
  referenceImageUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest
 */
export type CreateMockupCreatorTemplateRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 3;
   */
  replaceableObjects?: ReplaceableObjectJson[];

  /**
   * Provide reference_image to mint a presigned upload URL the caller will
   * then PUT the bytes to. Mutually exclusive with reference_image_url.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent reference_image = 4;
   */
  referenceImage?: CreateMockupCreatorTemplateRequest_RequestImageContentJson;

  /**
   * Provide reference_image_url to skip uploading and persist an existing
   * public URL as the template's reference image. Mutually exclusive with
   * reference_image.
   *
   * @generated from field: string reference_image_url = 5;
   */
  referenceImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.
 * Use `create(CreateMockupCreatorTemplateRequestSchema)` to create a new message.
 */
export const CreateMockupCreatorTemplateRequestSchema: GenMessage<CreateMockupCreatorTemplateRequest, {jsonType: CreateMockupCreatorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 19);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent
 */
export type CreateMockupCreatorTemplateRequest_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent
 */
export type CreateMockupCreatorTemplateRequest_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateRequest.RequestImageContent.
 * Use `create(CreateMockupCreatorTemplateRequest_RequestImageContentSchema)` to create a new message.
 */
export const CreateMockupCreatorTemplateRequest_RequestImageContentSchema: GenMessage<CreateMockupCreatorTemplateRequest_RequestImageContent, {jsonType: CreateMockupCreatorTemplateRequest_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 19, 0);

/**
 * PresignedUpload describes a presigned POST upload form. The client must
 * submit a multipart/form-data POST to `url` including every entry in
 * `form_fields` as a form field, plus the `file` field with the bytes. The
 * caller controls the Content-Type by passing it as a form field.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.PresignedUpload
 */
export type PresignedUpload = Message<"creativefabrica.studiomediamatrix.v1.PresignedUpload"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: map<string, string> form_fields = 2;
   */
  formFields: { [key: string]: string };
};

/**
 * PresignedUpload describes a presigned POST upload form. The client must
 * submit a multipart/form-data POST to `url` including every entry in
 * `form_fields` as a form field, plus the `file` field with the bytes. The
 * caller controls the Content-Type by passing it as a form field.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.PresignedUpload
 */
export type PresignedUploadJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: map<string, string> form_fields = 2;
   */
  formFields?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PresignedUpload.
 * Use `create(PresignedUploadSchema)` to create a new message.
 */
export const PresignedUploadSchema: GenMessage<PresignedUpload, {jsonType: PresignedUploadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 20);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateResponse
 */
export type CreateMockupCreatorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateResponse"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * Presigned upload form for the reference_image bytes. Set only when the
   * request included reference_image metadata. Unset otherwise.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PresignedUpload reference_image_upload = 2;
   */
  referenceImageUpload?: PresignedUpload | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateResponse
 */
export type CreateMockupCreatorTemplateResponseJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * Presigned upload form for the reference_image bytes. Set only when the
   * request included reference_image metadata. Unset otherwise.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PresignedUpload reference_image_upload = 2;
   */
  referenceImageUpload?: PresignedUploadJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateMockupCreatorTemplateResponse.
 * Use `create(CreateMockupCreatorTemplateResponseSchema)` to create a new message.
 */
export const CreateMockupCreatorTemplateResponseSchema: GenMessage<CreateMockupCreatorTemplateResponse, {jsonType: CreateMockupCreatorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 21);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest
 */
export type UpdateMockupCreatorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 4;
   */
  replaceableObjects: ReplaceableObject[];

  /**
   * Provide reference_image to mint a presigned upload URL. Mutually
   * exclusive with reference_image_url.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent reference_image = 5;
   */
  referenceImage?: UpdateMockupCreatorTemplateRequest_RequestImageContent | undefined;

  /**
   * Provide reference_image_url to replace the template's reference image
   * with an existing public URL. Mutually exclusive with reference_image.
   *
   * @generated from field: optional string reference_image_url = 6;
   */
  referenceImageUrl?: string | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest
 */
export type UpdateMockupCreatorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 4;
   */
  replaceableObjects?: ReplaceableObjectJson[];

  /**
   * Provide reference_image to mint a presigned upload URL. Mutually
   * exclusive with reference_image_url.
   *
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent reference_image = 5;
   */
  referenceImage?: UpdateMockupCreatorTemplateRequest_RequestImageContentJson;

  /**
   * Provide reference_image_url to replace the template's reference image
   * with an existing public URL. Mutually exclusive with reference_image.
   *
   * @generated from field: optional string reference_image_url = 6;
   */
  referenceImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.
 * Use `create(UpdateMockupCreatorTemplateRequestSchema)` to create a new message.
 */
export const UpdateMockupCreatorTemplateRequestSchema: GenMessage<UpdateMockupCreatorTemplateRequest, {jsonType: UpdateMockupCreatorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 22);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent
 */
export type UpdateMockupCreatorTemplateRequest_RequestImageContent = Message<"creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent"> & {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent
 */
export type UpdateMockupCreatorTemplateRequest_RequestImageContentJson = {
  /**
   * @generated from field: int64 file_size = 1;
   */
  fileSize?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateRequest.RequestImageContent.
 * Use `create(UpdateMockupCreatorTemplateRequest_RequestImageContentSchema)` to create a new message.
 */
export const UpdateMockupCreatorTemplateRequest_RequestImageContentSchema: GenMessage<UpdateMockupCreatorTemplateRequest_RequestImageContent, {jsonType: UpdateMockupCreatorTemplateRequest_RequestImageContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 22, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateResponse
 */
export type UpdateMockupCreatorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateResponse"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * Presigned upload form for the reference_image bytes. Set only when the
   * request included reference_image metadata. Unset otherwise.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PresignedUpload reference_image_upload = 2;
   */
  referenceImageUpload?: PresignedUpload | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateResponse
 */
export type UpdateMockupCreatorTemplateResponseJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * Presigned upload form for the reference_image bytes. Set only when the
   * request included reference_image metadata. Unset otherwise.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.PresignedUpload reference_image_upload = 2;
   */
  referenceImageUpload?: PresignedUploadJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateMockupCreatorTemplateResponse.
 * Use `create(UpdateMockupCreatorTemplateResponseSchema)` to create a new message.
 */
export const UpdateMockupCreatorTemplateResponseSchema: GenMessage<UpdateMockupCreatorTemplateResponse, {jsonType: UpdateMockupCreatorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 23);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateRequest
 */
export type PublishMockupCreatorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateRequest
 */
export type PublishMockupCreatorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateRequest.
 * Use `create(PublishMockupCreatorTemplateRequestSchema)` to create a new message.
 */
export const PublishMockupCreatorTemplateRequestSchema: GenMessage<PublishMockupCreatorTemplateRequest, {jsonType: PublishMockupCreatorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 24);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateResponse
 */
export type PublishMockupCreatorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateResponse
 */
export type PublishMockupCreatorTemplateResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PublishMockupCreatorTemplateResponse.
 * Use `create(PublishMockupCreatorTemplateResponseSchema)` to create a new message.
 */
export const PublishMockupCreatorTemplateResponseSchema: GenMessage<PublishMockupCreatorTemplateResponse, {jsonType: PublishMockupCreatorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 25);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue
 */
export type ReplaceableObjectValue = Message<"creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue.value
   */
  value: {
    /**
     * @generated from field: bool unchanged = 1;
     */
    value: boolean;
    case: "unchanged";
  } | {
    /**
     * @generated from field: string prompt = 2;
     */
    value: string;
    case: "prompt";
  } | {
    /**
     * @generated from field: string file = 3;
     */
    value: string;
    case: "file";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue
 */
export type ReplaceableObjectValueJson = {
  /**
   * @generated from field: bool unchanged = 1;
   */
  unchanged?: boolean;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt?: string;

  /**
   * @generated from field: string file = 3;
   */
  file?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue.
 * Use `create(ReplaceableObjectValueSchema)` to create a new message.
 */
export const ReplaceableObjectValueSchema: GenMessage<ReplaceableObjectValue, {jsonType: ReplaceableObjectValueJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 26);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput
 */
export type GenerateFromMockupCreatorTemplateInput = Message<"creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput"> & {
  /**
   * @generated from field: map<string, creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue> replaceable_objects = 1;
   */
  replaceableObjects: { [key: string]: ReplaceableObjectValue };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput
 */
export type GenerateFromMockupCreatorTemplateInputJson = {
  /**
   * @generated from field: map<string, creativefabrica.studiomediamatrix.v1.ReplaceableObjectValue> replaceable_objects = 1;
   */
  replaceableObjects?: { [key: string]: ReplaceableObjectValueJson };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput.
 * Use `create(GenerateFromMockupCreatorTemplateInputSchema)` to create a new message.
 */
export const GenerateFromMockupCreatorTemplateInputSchema: GenMessage<GenerateFromMockupCreatorTemplateInput, {jsonType: GenerateFromMockupCreatorTemplateInputJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 27);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateRequest
 */
export type GenerateFromMockupCreatorTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput input = 2;
   */
  input?: GenerateFromMockupCreatorTemplateInput | undefined;

  /**
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateRequest
 */
export type GenerateFromMockupCreatorTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateInput input = 2;
   */
  input?: GenerateFromMockupCreatorTemplateInputJson;

  /**
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateRequest.
 * Use `create(GenerateFromMockupCreatorTemplateRequestSchema)` to create a new message.
 */
export const GenerateFromMockupCreatorTemplateRequestSchema: GenMessage<GenerateFromMockupCreatorTemplateRequest, {jsonType: GenerateFromMockupCreatorTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 28);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateResponse
 */
export type GenerateFromMockupCreatorTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Iteration iteration = 2;
   */
  iteration?: Iteration | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateResponse
 */
export type GenerateFromMockupCreatorTemplateResponseJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Iteration iteration = 2;
   */
  iteration?: IterationJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GenerateFromMockupCreatorTemplateResponse.
 * Use `create(GenerateFromMockupCreatorTemplateResponseSchema)` to create a new message.
 */
export const GenerateFromMockupCreatorTemplateResponseSchema: GenMessage<GenerateFromMockupCreatorTemplateResponse, {jsonType: GenerateFromMockupCreatorTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 29);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate
 */
export type MockupCreatorTemplate = Message<"creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 4;
   */
  replaceableObjects: ReplaceableObject[];

  /**
   * URL of the persisted reference image, used as the input file at
   * generation time. Empty when the template has no reference image.
   *
   * @generated from field: string reference_image_url = 5;
   */
  referenceImageUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate
 */
export type MockupCreatorTemplateJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ReplaceableObject replaceable_objects = 4;
   */
  replaceableObjects?: ReplaceableObjectJson[];

  /**
   * URL of the persisted reference image, used as the input file at
   * generation time. Empty when the template has no reference image.
   *
   * @generated from field: string reference_image_url = 5;
   */
  referenceImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate.
 * Use `create(MockupCreatorTemplateSchema)` to create a new message.
 */
export const MockupCreatorTemplateSchema: GenMessage<MockupCreatorTemplate, {jsonType: MockupCreatorTemplateJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 30);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesRequest
 */
export type ListMockupCreatorTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesRequest
 */
export type ListMockupCreatorTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesRequest.
 * Use `create(ListMockupCreatorTemplatesRequestSchema)` to create a new message.
 */
export const ListMockupCreatorTemplatesRequestSchema: GenMessage<ListMockupCreatorTemplatesRequest, {jsonType: ListMockupCreatorTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 31);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesResponse
 */
export type ListMockupCreatorTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate presets = 1;
   */
  presets: MockupCreatorTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesResponse
 */
export type ListMockupCreatorTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MockupCreatorTemplate presets = 1;
   */
  presets?: MockupCreatorTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMockupCreatorTemplatesResponse.
 * Use `create(ListMockupCreatorTemplatesResponseSchema)` to create a new message.
 */
export const ListMockupCreatorTemplatesResponseSchema: GenMessage<ListMockupCreatorTemplatesResponse, {jsonType: ListMockupCreatorTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 32);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPhotoStyleRequest
 */
export type GetPhotoStyleRequest = Message<"creativefabrica.studiomediamatrix.v1.GetPhotoStyleRequest"> & {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPhotoStyleRequest
 */
export type GetPhotoStyleRequestJson = {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPhotoStyleRequest.
 * Use `create(GetPhotoStyleRequestSchema)` to create a new message.
 */
export const GetPhotoStyleRequestSchema: GenMessage<GetPhotoStyleRequest, {jsonType: GetPhotoStyleRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 33);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPhotoStyleResponse
 */
export type GetPhotoStyleResponse = Message<"creativefabrica.studiomediamatrix.v1.GetPhotoStyleResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyle style = 1;
   */
  style?: AIPhotoStyle | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPhotoStyleResponse
 */
export type GetPhotoStyleResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyle style = 1;
   */
  style?: AIPhotoStyleJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPhotoStyleResponse.
 * Use `create(GetPhotoStyleResponseSchema)` to create a new message.
 */
export const GetPhotoStyleResponseSchema: GenMessage<GetPhotoStyleResponse, {jsonType: GetPhotoStyleResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 34);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleRequest
 */
export type FavoritePhotoStyleRequest = Message<"creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleRequest"> & {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleRequest
 */
export type FavoritePhotoStyleRequestJson = {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleRequest.
 * Use `create(FavoritePhotoStyleRequestSchema)` to create a new message.
 */
export const FavoritePhotoStyleRequestSchema: GenMessage<FavoritePhotoStyleRequest, {jsonType: FavoritePhotoStyleRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 35);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleResponse
 */
export type FavoritePhotoStyleResponse = Message<"creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleResponse
 */
export type FavoritePhotoStyleResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoritePhotoStyleResponse.
 * Use `create(FavoritePhotoStyleResponseSchema)` to create a new message.
 */
export const FavoritePhotoStyleResponseSchema: GenMessage<FavoritePhotoStyleResponse, {jsonType: FavoritePhotoStyleResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 36);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleRequest
 */
export type UnfavoritePhotoStyleRequest = Message<"creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleRequest"> & {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleRequest
 */
export type UnfavoritePhotoStyleRequestJson = {
  /**
   * @generated from field: string style_id = 1;
   */
  styleId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleRequest.
 * Use `create(UnfavoritePhotoStyleRequestSchema)` to create a new message.
 */
export const UnfavoritePhotoStyleRequestSchema: GenMessage<UnfavoritePhotoStyleRequest, {jsonType: UnfavoritePhotoStyleRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 37);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleResponse
 */
export type UnfavoritePhotoStyleResponse = Message<"creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleResponse
 */
export type UnfavoritePhotoStyleResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoritePhotoStyleResponse.
 * Use `create(UnfavoritePhotoStyleResponseSchema)` to create a new message.
 */
export const UnfavoritePhotoStyleResponseSchema: GenMessage<UnfavoritePhotoStyleResponse, {jsonType: UnfavoritePhotoStyleResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 38);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesRequest
 */
export type ListFavoritePhotoStylesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesRequest
 */
export type ListFavoritePhotoStylesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesRequest.
 * Use `create(ListFavoritePhotoStylesRequestSchema)` to create a new message.
 */
export const ListFavoritePhotoStylesRequestSchema: GenMessage<ListFavoritePhotoStylesRequest, {jsonType: ListFavoritePhotoStylesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 39);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesResponse
 */
export type ListFavoritePhotoStylesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIPhotoStyle styles = 1;
   */
  styles: AIPhotoStyle[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesResponse
 */
export type ListFavoritePhotoStylesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIPhotoStyle styles = 1;
   */
  styles?: AIPhotoStyleJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoritePhotoStylesResponse.
 * Use `create(ListFavoritePhotoStylesResponseSchema)` to create a new message.
 */
export const ListFavoritePhotoStylesResponseSchema: GenMessage<ListFavoritePhotoStylesResponse, {jsonType: ListFavoritePhotoStylesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 40);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListPhotoStylesRequest
 */
export type ListPhotoStylesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListPhotoStylesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListPhotoStylesRequest
 */
export type ListPhotoStylesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListPhotoStylesRequest.
 * Use `create(ListPhotoStylesRequestSchema)` to create a new message.
 */
export const ListPhotoStylesRequestSchema: GenMessage<ListPhotoStylesRequest, {jsonType: ListPhotoStylesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 41);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListPhotoStylesResponse
 */
export type ListPhotoStylesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListPhotoStylesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIPhotoStyle styles = 1;
   */
  styles: AIPhotoStyle[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListPhotoStylesResponse
 */
export type ListPhotoStylesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.AIPhotoStyle styles = 1;
   */
  styles?: AIPhotoStyleJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListPhotoStylesResponse.
 * Use `create(ListPhotoStylesResponseSchema)` to create a new message.
 */
export const ListPhotoStylesResponseSchema: GenMessage<ListPhotoStylesResponse, {jsonType: ListPhotoStylesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 42);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesRequest
 */
export type ListYouTubeThumbnailTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesRequest
 */
export type ListYouTubeThumbnailTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesRequest.
 * Use `create(ListYouTubeThumbnailTemplatesRequestSchema)` to create a new message.
 */
export const ListYouTubeThumbnailTemplatesRequestSchema: GenMessage<ListYouTubeThumbnailTemplatesRequest, {jsonType: ListYouTubeThumbnailTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 43);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesResponse
 */
export type ListYouTubeThumbnailTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate templates = 1;
   */
  templates: YouTubeThumbnailTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesResponse
 */
export type ListYouTubeThumbnailTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate templates = 1;
   */
  templates?: YouTubeThumbnailTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListYouTubeThumbnailTemplatesResponse.
 * Use `create(ListYouTubeThumbnailTemplatesResponseSchema)` to create a new message.
 */
export const ListYouTubeThumbnailTemplatesResponseSchema: GenMessage<ListYouTubeThumbnailTemplatesResponse, {jsonType: ListYouTubeThumbnailTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 44);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateRequest
 */
export type GetYouTubeThumbnailTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateRequest
 */
export type GetYouTubeThumbnailTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateRequest.
 * Use `create(GetYouTubeThumbnailTemplateRequestSchema)` to create a new message.
 */
export const GetYouTubeThumbnailTemplateRequestSchema: GenMessage<GetYouTubeThumbnailTemplateRequest, {jsonType: GetYouTubeThumbnailTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 45);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateResponse
 */
export type GetYouTubeThumbnailTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate template = 1;
   */
  template?: YouTubeThumbnailTemplate | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateResponse
 */
export type GetYouTubeThumbnailTemplateResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate template = 1;
   */
  template?: YouTubeThumbnailTemplateJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetYouTubeThumbnailTemplateResponse.
 * Use `create(GetYouTubeThumbnailTemplateResponseSchema)` to create a new message.
 */
export const GetYouTubeThumbnailTemplateResponseSchema: GenMessage<GetYouTubeThumbnailTemplateResponse, {jsonType: GetYouTubeThumbnailTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 46);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateRequest
 */
export type FavoriteYouTubeThumbnailTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateRequest
 */
export type FavoriteYouTubeThumbnailTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateRequest.
 * Use `create(FavoriteYouTubeThumbnailTemplateRequestSchema)` to create a new message.
 */
export const FavoriteYouTubeThumbnailTemplateRequestSchema: GenMessage<FavoriteYouTubeThumbnailTemplateRequest, {jsonType: FavoriteYouTubeThumbnailTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 47);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateResponse
 */
export type FavoriteYouTubeThumbnailTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateResponse
 */
export type FavoriteYouTubeThumbnailTemplateResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteYouTubeThumbnailTemplateResponse.
 * Use `create(FavoriteYouTubeThumbnailTemplateResponseSchema)` to create a new message.
 */
export const FavoriteYouTubeThumbnailTemplateResponseSchema: GenMessage<FavoriteYouTubeThumbnailTemplateResponse, {jsonType: FavoriteYouTubeThumbnailTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 48);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateRequest
 */
export type UnfavoriteYouTubeThumbnailTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateRequest
 */
export type UnfavoriteYouTubeThumbnailTemplateRequestJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateRequest.
 * Use `create(UnfavoriteYouTubeThumbnailTemplateRequestSchema)` to create a new message.
 */
export const UnfavoriteYouTubeThumbnailTemplateRequestSchema: GenMessage<UnfavoriteYouTubeThumbnailTemplateRequest, {jsonType: UnfavoriteYouTubeThumbnailTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 49);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateResponse
 */
export type UnfavoriteYouTubeThumbnailTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateResponse
 */
export type UnfavoriteYouTubeThumbnailTemplateResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteYouTubeThumbnailTemplateResponse.
 * Use `create(UnfavoriteYouTubeThumbnailTemplateResponseSchema)` to create a new message.
 */
export const UnfavoriteYouTubeThumbnailTemplateResponseSchema: GenMessage<UnfavoriteYouTubeThumbnailTemplateResponse, {jsonType: UnfavoriteYouTubeThumbnailTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 50);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesRequest
 */
export type ListFavoriteYouTubeThumbnailTemplatesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesRequest
 */
export type ListFavoriteYouTubeThumbnailTemplatesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesRequest.
 * Use `create(ListFavoriteYouTubeThumbnailTemplatesRequestSchema)` to create a new message.
 */
export const ListFavoriteYouTubeThumbnailTemplatesRequestSchema: GenMessage<ListFavoriteYouTubeThumbnailTemplatesRequest, {jsonType: ListFavoriteYouTubeThumbnailTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 51);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesResponse
 */
export type ListFavoriteYouTubeThumbnailTemplatesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate templates = 1;
   */
  templates: YouTubeThumbnailTemplate[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesResponse
 */
export type ListFavoriteYouTubeThumbnailTemplatesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.YouTubeThumbnailTemplate templates = 1;
   */
  templates?: YouTubeThumbnailTemplateJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteYouTubeThumbnailTemplatesResponse.
 * Use `create(ListFavoriteYouTubeThumbnailTemplatesResponseSchema)` to create a new message.
 */
export const ListFavoriteYouTubeThumbnailTemplatesResponseSchema: GenMessage<ListFavoriteYouTubeThumbnailTemplatesResponse, {jsonType: ListFavoriteYouTubeThumbnailTemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 52);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionRequest
 */
export type UpdateSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.UpdateSessionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * Leave SESSION_VISIBILITY_UNSPECIFIED when metadata is set.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 3;
   */
  visibility: SessionVisibility;

  /**
   * Keys to set on Session.metadata, merged into the existing metadata (other
   * keys are kept; a key sent again is overwritten). Set exactly one of
   * visibility and metadata. Only keys the service type allows are accepted;
   * any other key fails with INVALID_ARGUMENT on "metadata". Allowed today:
   *   SERVICE_TYPE_VIDEO_DRAFT:
   *     cf_video_upscaler_session_id — the SERVICE_TYPE_VIDEO_UPSCALER session the draft
   *     was upscaled in; it must belong to the caller.
   *
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionRequest
 */
export type UpdateSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * Leave SESSION_VISIBILITY_UNSPECIFIED when metadata is set.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 3;
   */
  visibility?: SessionVisibilityJson;

  /**
   * Keys to set on Session.metadata, merged into the existing metadata (other
   * keys are kept; a key sent again is overwritten). Set exactly one of
   * visibility and metadata. Only keys the service type allows are accepted;
   * any other key fails with INVALID_ARGUMENT on "metadata". Allowed today:
   *   SERVICE_TYPE_VIDEO_DRAFT:
   *     cf_video_upscaler_session_id — the SERVICE_TYPE_VIDEO_UPSCALER session the draft
   *     was upscaled in; it must belong to the caller.
   *
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateSessionRequest.
 * Use `create(UpdateSessionRequestSchema)` to create a new message.
 */
export const UpdateSessionRequestSchema: GenMessage<UpdateSessionRequest, {jsonType: UpdateSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 53);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionResponse
 */
export type UpdateSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.UpdateSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionResponse
 */
export type UpdateSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateSessionResponse.
 * Use `create(UpdateSessionResponseSchema)` to create a new message.
 */
export const UpdateSessionResponseSchema: GenMessage<UpdateSessionResponse, {jsonType: UpdateSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 54);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemRequest
 */
export type UpdateSessionMediaItemRequest = Message<"creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string media_item_id = 2;
   */
  mediaItemId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 3;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemRequest.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.UpdateAudioContent audio_content = 4;
     */
    value: UpdateAudioContent;
    case: "audioContent";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemRequest
 */
export type UpdateSessionMediaItemRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string media_item_id = 2;
   */
  mediaItemId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 3;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.UpdateAudioContent audio_content = 4;
   */
  audioContent?: UpdateAudioContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemRequest.
 * Use `create(UpdateSessionMediaItemRequestSchema)` to create a new message.
 */
export const UpdateSessionMediaItemRequestSchema: GenMessage<UpdateSessionMediaItemRequest, {jsonType: UpdateSessionMediaItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 55);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateAudioContent
 */
export type UpdateAudioContent = Message<"creativefabrica.studiomediamatrix.v1.UpdateAudioContent"> & {
  /**
   * @generated from field: optional string cover_image_url = 1;
   */
  coverImageUrl?: string | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateAudioContent
 */
export type UpdateAudioContentJson = {
  /**
   * @generated from field: optional string cover_image_url = 1;
   */
  coverImageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateAudioContent.
 * Use `create(UpdateAudioContentSchema)` to create a new message.
 */
export const UpdateAudioContentSchema: GenMessage<UpdateAudioContent, {jsonType: UpdateAudioContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 56);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemResponse
 */
export type UpdateSessionMediaItemResponse = Message<"creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 1;
   */
  mediaItem?: MediaItem | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemResponse
 */
export type UpdateSessionMediaItemResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 1;
   */
  mediaItem?: MediaItemJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UpdateSessionMediaItemResponse.
 * Use `create(UpdateSessionMediaItemResponseSchema)` to create a new message.
 */
export const UpdateSessionMediaItemResponseSchema: GenMessage<UpdateSessionMediaItemResponse, {jsonType: UpdateSessionMediaItemResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 57);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.IterateSessionRequest
 */
export type IterateSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.IterateSessionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.IterateSessionRequest.request
   */
  request: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestImageContent session_request_image_content = 3;
     */
    value: SessionRequestImageContent;
    case: "sessionRequestImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent session_request_prompt_content = 4;
     */
    value: SessionRequestPromptContent;
    case: "sessionRequestPromptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent session_request_prompt_with_images_content = 5;
     */
    value: SessionRequestPromptWithImagesContent;
    case: "sessionRequestPromptWithImagesContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent session_request_prompt_music_generator_content = 6;
     */
    value: SessionRequestPromptMusicGeneratorContent;
    case: "sessionRequestPromptMusicGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent session_request_prompt_sound_generator_content = 7;
     */
    value: SessionRequestPromptSoundGeneratorContent;
    case: "sessionRequestPromptSoundGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent session_request_prompt_speech_generator_content = 8;
     */
    value: SessionRequestPromptSpeechGeneratorContent;
    case: "sessionRequestPromptSpeechGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent session_request_collage_maker_content = 9;
     */
    value: SessionRequestCollageMakerContent;
    case: "sessionRequestCollageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType predefined_action = 11;
     */
    value: ActionType;
    case: "predefinedAction";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent session_request_camera_angle_content = 12;
     */
    value: SessionRequestCameraAngleContent;
    case: "sessionRequestCameraAngleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent session_request_marketplace_editor_content = 13;
     */
    value: SessionRequestMarketplaceEditorContent;
    case: "sessionRequestMarketplaceEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent session_request_ai_svg_generator_content = 14;
     */
    value: SessionRequestAISVGGeneratorContent;
    case: "sessionRequestAiSvgGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent session_request_video_cutouts_content = 15;
     */
    value: SessionRequestVideoCutoutsContent;
    case: "sessionRequestVideoCutoutsContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent session_request_prompt_music_lyrics_structured_content = 16;
     */
    value: SessionRequestPromptMusicLyricsStructuredContent;
    case: "sessionRequestPromptMusicLyricsStructuredContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent session_request_video_editor_prompt_content = 17;
     */
    value: SessionRequestVideoEditorPromptContent;
    case: "sessionRequestVideoEditorPromptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent session_request_inpaint_content = 18;
     */
    value: SessionRequestInpaintContent;
    case: "sessionRequestInpaintContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent session_request_ad_banner_resizer_sizes_content = 19;
     */
    value: SessionRequestAdBannerResizerSizesContent;
    case: "sessionRequestAdBannerResizerSizesContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 10;
   */
  visibility?: SessionVisibility | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.IterateSessionRequest
 */
export type IterateSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestImageContent session_request_image_content = 3;
   */
  sessionRequestImageContent?: SessionRequestImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent session_request_prompt_content = 4;
   */
  sessionRequestPromptContent?: SessionRequestPromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent session_request_prompt_with_images_content = 5;
   */
  sessionRequestPromptWithImagesContent?: SessionRequestPromptWithImagesContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent session_request_prompt_music_generator_content = 6;
   */
  sessionRequestPromptMusicGeneratorContent?: SessionRequestPromptMusicGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent session_request_prompt_sound_generator_content = 7;
   */
  sessionRequestPromptSoundGeneratorContent?: SessionRequestPromptSoundGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent session_request_prompt_speech_generator_content = 8;
   */
  sessionRequestPromptSpeechGeneratorContent?: SessionRequestPromptSpeechGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent session_request_collage_maker_content = 9;
   */
  sessionRequestCollageMakerContent?: SessionRequestCollageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType predefined_action = 11;
   */
  predefinedAction?: ActionTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent session_request_camera_angle_content = 12;
   */
  sessionRequestCameraAngleContent?: SessionRequestCameraAngleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent session_request_marketplace_editor_content = 13;
   */
  sessionRequestMarketplaceEditorContent?: SessionRequestMarketplaceEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent session_request_ai_svg_generator_content = 14;
   */
  sessionRequestAiSvgGeneratorContent?: SessionRequestAISVGGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent session_request_video_cutouts_content = 15;
   */
  sessionRequestVideoCutoutsContent?: SessionRequestVideoCutoutsContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent session_request_prompt_music_lyrics_structured_content = 16;
   */
  sessionRequestPromptMusicLyricsStructuredContent?: SessionRequestPromptMusicLyricsStructuredContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorPromptContent session_request_video_editor_prompt_content = 17;
   */
  sessionRequestVideoEditorPromptContent?: SessionRequestVideoEditorPromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent session_request_inpaint_content = 18;
   */
  sessionRequestInpaintContent?: SessionRequestInpaintContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerSizesContent session_request_ad_banner_resizer_sizes_content = 19;
   */
  sessionRequestAdBannerResizerSizesContent?: SessionRequestAdBannerResizerSizesContentJson;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 10;
   */
  visibility?: SessionVisibilityJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.IterateSessionRequest.
 * Use `create(IterateSessionRequestSchema)` to create a new message.
 */
export const IterateSessionRequestSchema: GenMessage<IterateSessionRequest, {jsonType: IterateSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 58);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.IterateSessionResponse
 */
export type IterateSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.IterateSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Iteration iteration = 1;
   */
  iteration?: Iteration | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.IterateSessionResponse
 */
export type IterateSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Iteration iteration = 1;
   */
  iteration?: IterationJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.IterateSessionResponse.
 * Use `create(IterateSessionResponseSchema)` to create a new message.
 */
export const IterateSessionResponseSchema: GenMessage<IterateSessionResponse, {jsonType: IterateSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 59);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionIterationsRequest
 */
export type GetSessionIterationsRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionIterationsRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionIterationsRequest
 */
export type GetSessionIterationsRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionIterationsRequest.
 * Use `create(GetSessionIterationsRequestSchema)` to create a new message.
 */
export const GetSessionIterationsRequestSchema: GenMessage<GetSessionIterationsRequest, {jsonType: GetSessionIterationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 60);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionIterationsResponse
 */
export type GetSessionIterationsResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionIterationsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Iteration iterations = 1;
   */
  iterations: Iteration[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionIterationsResponse
 */
export type GetSessionIterationsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Iteration iterations = 1;
   */
  iterations?: IterationJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionIterationsResponse.
 * Use `create(GetSessionIterationsResponseSchema)` to create a new message.
 */
export const GetSessionIterationsResponseSchema: GenMessage<GetSessionIterationsResponse, {jsonType: GetSessionIterationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 61);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionImagesRequest
 */
export type GetSessionImagesRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionImagesRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionImagesRequest
 */
export type GetSessionImagesRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionImagesRequest.
 * Use `create(GetSessionImagesRequestSchema)` to create a new message.
 */
export const GetSessionImagesRequestSchema: GenMessage<GetSessionImagesRequest, {jsonType: GetSessionImagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 62);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionImagesResponse
 */
export type GetSessionImagesResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionImagesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 1;
   */
  images: Image[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionImagesResponse
 */
export type GetSessionImagesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 1;
   */
  images?: ImageJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionImagesResponse.
 * Use `create(GetSessionImagesResponseSchema)` to create a new message.
 */
export const GetSessionImagesResponseSchema: GenMessage<GetSessionImagesResponse, {jsonType: GetSessionImagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 63);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionMediaRequest
 */
export type GetSessionMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionMediaRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionMediaRequest
 */
export type GetSessionMediaRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionMediaRequest.
 * Use `create(GetSessionMediaRequestSchema)` to create a new message.
 */
export const GetSessionMediaRequestSchema: GenMessage<GetSessionMediaRequest, {jsonType: GetSessionMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 64);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionMediaResponse
 */
export type GetSessionMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionMediaResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem items = 1;
   */
  items: MediaItem[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionMediaResponse
 */
export type GetSessionMediaResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem items = 1;
   */
  items?: MediaItemJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionMediaResponse.
 * Use `create(GetSessionMediaResponseSchema)` to create a new message.
 */
export const GetSessionMediaResponseSchema: GenMessage<GetSessionMediaResponse, {jsonType: GetSessionMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 65);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaRequest
 */
export type GetSessionInputMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionInputMediaRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * Optional: restrict to one round's inputs (e.g. rendering what a single
   * historical generation used). Empty returns the whole session's inputs.
   *
   * @generated from field: string iteration_id = 3;
   */
  iterationId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaRequest
 */
export type GetSessionInputMediaRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * Optional: restrict to one round's inputs (e.g. rendering what a single
   * historical generation used). Empty returns the whole session's inputs.
   *
   * @generated from field: string iteration_id = 3;
   */
  iterationId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaRequest.
 * Use `create(GetSessionInputMediaRequestSchema)` to create a new message.
 */
export const GetSessionInputMediaRequestSchema: GenMessage<GetSessionInputMediaRequest, {jsonType: GetSessionInputMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 66);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaResponse
 */
export type GetSessionInputMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionInputMediaResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InputMedia input_media = 1;
   */
  inputMedia: InputMedia[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaResponse
 */
export type GetSessionInputMediaResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InputMedia input_media = 1;
   */
  inputMedia?: InputMediaJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionInputMediaResponse.
 * Use `create(GetSessionInputMediaResponseSchema)` to create a new message.
 */
export const GetSessionInputMediaResponseSchema: GenMessage<GetSessionInputMediaResponse, {jsonType: GetSessionInputMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 67);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateSessionRequest
 */
export type InitiateSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.InitiateSessionRequest"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.InitiateSessionRequest.request
   */
  request: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestImageContent session_request_image_content = 1;
     */
    value: SessionRequestImageContent;
    case: "sessionRequestImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent session_request_prompt_content = 2;
     */
    value: SessionRequestPromptContent;
    case: "sessionRequestPromptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent session_request_prompt_with_images_content = 3;
     */
    value: SessionRequestPromptWithImagesContent;
    case: "sessionRequestPromptWithImagesContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent session_request_prompt_music_generator_content = 4;
     */
    value: SessionRequestPromptMusicGeneratorContent;
    case: "sessionRequestPromptMusicGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent session_request_prompt_sound_generator_content = 6;
     */
    value: SessionRequestPromptSoundGeneratorContent;
    case: "sessionRequestPromptSoundGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent session_request_prompt_speech_generator_content = 7;
     */
    value: SessionRequestPromptSpeechGeneratorContent;
    case: "sessionRequestPromptSpeechGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent session_request_collage_maker_content = 8;
     */
    value: SessionRequestCollageMakerContent;
    case: "sessionRequestCollageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent session_request_source_from_image_content = 9;
     */
    value: SessionRequestSourceFromImageContent;
    case: "sessionRequestSourceFromImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent session_request_text_cad_content = 10;
     */
    value: SessionRequestTextCADContent;
    case: "sessionRequestTextCadContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent session_request_doodle_pet_content = 11;
     */
    value: SessionRequestDoodlePetContent;
    case: "sessionRequestDoodlePetContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent session_request_coloring_page_maker_content = 13;
     */
    value: SessionRequestColoringPageMakerContent;
    case: "sessionRequestColoringPageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent session_request_prompt_to_video_generator_content = 14;
     */
    value: SessionRequestPromptToVideoGeneratorContent;
    case: "sessionRequestPromptToVideoGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent session_request_wedding_invite_content = 15;
     */
    value: SessionRequestWeddingInviteContent;
    case: "sessionRequestWeddingInviteContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent session_request_etsy_coach_content = 16;
     */
    value: SessionRequestEtsyCoachContent;
    case: "sessionRequestEtsyCoachContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent session_request_ai_photo_style_content = 17;
     */
    value: SessionRequestAIPhotoStyleContent;
    case: "sessionRequestAiPhotoStyleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent session_request_toon_family_content = 18;
     */
    value: SessionRequestToonFamilyContent;
    case: "sessionRequestToonFamilyContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent session_request_text_mesh_content = 19;
     */
    value: SessionRequestTextMeshContent;
    case: "sessionRequestTextMeshContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent session_request_logo_generator_content = 20;
     */
    value: SessionRequestLogoGeneratorContent;
    case: "sessionRequestLogoGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent session_request_video_upscaler_content = 21;
     */
    value: SessionRequestVideoUpscalerContent;
    case: "sessionRequestVideoUpscalerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent session_request_ai_mockup_generator_content = 22;
     */
    value: SessionRequestAIMockupGeneratorContent;
    case: "sessionRequestAiMockupGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent session_request_camera_angle_content = 23;
     */
    value: SessionRequestCameraAngleContent;
    case: "sessionRequestCameraAngleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent session_request_marketplace_editor_content = 24;
     */
    value: SessionRequestMarketplaceEditorContent;
    case: "sessionRequestMarketplaceEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent session_request_ai_svg_generator_content = 25;
     */
    value: SessionRequestAISVGGeneratorContent;
    case: "sessionRequestAiSvgGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent session_request_splat_content = 27;
     */
    value: SessionRequestSplatContent;
    case: "sessionRequestSplatContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent session_request_video_cutouts_content = 28;
     */
    value: SessionRequestVideoCutoutsContent;
    case: "sessionRequestVideoCutoutsContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent session_request_prompt_music_lyrics_structured_content = 29;
     */
    value: SessionRequestPromptMusicLyricsStructuredContent;
    case: "sessionRequestPromptMusicLyricsStructuredContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent session_request_video_template_content = 30;
     */
    value: SessionRequestVideoTemplateContent;
    case: "sessionRequestVideoTemplateContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent session_request_video_editor_content = 31;
     */
    value: SessionRequestVideoEditorContent;
    case: "sessionRequestVideoEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent session_request_youtube_thumbnail_generator_content = 32;
     */
    value: SessionRequestYouTubeThumbnailGeneratorContent;
    case: "sessionRequestYoutubeThumbnailGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent session_request_inpaint_content = 33;
     */
    value: SessionRequestInpaintContent;
    case: "sessionRequestInpaintContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent session_request_ad_banner_resizer_content = 34;
     */
    value: SessionRequestAdBannerResizerContent;
    case: "sessionRequestAdBannerResizerContent";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 5;
   */
  visibility: SessionVisibility;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Source source = 26;
   */
  source: Source;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateSessionRequest
 */
export type InitiateSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestImageContent session_request_image_content = 1;
   */
  sessionRequestImageContent?: SessionRequestImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptContent session_request_prompt_content = 2;
   */
  sessionRequestPromptContent?: SessionRequestPromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptWithImagesContent session_request_prompt_with_images_content = 3;
   */
  sessionRequestPromptWithImagesContent?: SessionRequestPromptWithImagesContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicGeneratorContent session_request_prompt_music_generator_content = 4;
   */
  sessionRequestPromptMusicGeneratorContent?: SessionRequestPromptMusicGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSoundGeneratorContent session_request_prompt_sound_generator_content = 6;
   */
  sessionRequestPromptSoundGeneratorContent?: SessionRequestPromptSoundGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptSpeechGeneratorContent session_request_prompt_speech_generator_content = 7;
   */
  sessionRequestPromptSpeechGeneratorContent?: SessionRequestPromptSpeechGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCollageMakerContent session_request_collage_maker_content = 8;
   */
  sessionRequestCollageMakerContent?: SessionRequestCollageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestSourceFromImageContent session_request_source_from_image_content = 9;
   */
  sessionRequestSourceFromImageContent?: SessionRequestSourceFromImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextCADContent session_request_text_cad_content = 10;
   */
  sessionRequestTextCadContent?: SessionRequestTextCADContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestDoodlePetContent session_request_doodle_pet_content = 11;
   */
  sessionRequestDoodlePetContent?: SessionRequestDoodlePetContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestColoringPageMakerContent session_request_coloring_page_maker_content = 13;
   */
  sessionRequestColoringPageMakerContent?: SessionRequestColoringPageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptToVideoGeneratorContent session_request_prompt_to_video_generator_content = 14;
   */
  sessionRequestPromptToVideoGeneratorContent?: SessionRequestPromptToVideoGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestWeddingInviteContent session_request_wedding_invite_content = 15;
   */
  sessionRequestWeddingInviteContent?: SessionRequestWeddingInviteContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestEtsyCoachContent session_request_etsy_coach_content = 16;
   */
  sessionRequestEtsyCoachContent?: SessionRequestEtsyCoachContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAIPhotoStyleContent session_request_ai_photo_style_content = 17;
   */
  sessionRequestAiPhotoStyleContent?: SessionRequestAIPhotoStyleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestToonFamilyContent session_request_toon_family_content = 18;
   */
  sessionRequestToonFamilyContent?: SessionRequestToonFamilyContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestTextMeshContent session_request_text_mesh_content = 19;
   */
  sessionRequestTextMeshContent?: SessionRequestTextMeshContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestLogoGeneratorContent session_request_logo_generator_content = 20;
   */
  sessionRequestLogoGeneratorContent?: SessionRequestLogoGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoUpscalerContent session_request_video_upscaler_content = 21;
   */
  sessionRequestVideoUpscalerContent?: SessionRequestVideoUpscalerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAIMockupGeneratorContent session_request_ai_mockup_generator_content = 22;
   */
  sessionRequestAiMockupGeneratorContent?: SessionRequestAIMockupGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestCameraAngleContent session_request_camera_angle_content = 23;
   */
  sessionRequestCameraAngleContent?: SessionRequestCameraAngleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestMarketplaceEditorContent session_request_marketplace_editor_content = 24;
   */
  sessionRequestMarketplaceEditorContent?: SessionRequestMarketplaceEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAISVGGeneratorContent session_request_ai_svg_generator_content = 25;
   */
  sessionRequestAiSvgGeneratorContent?: SessionRequestAISVGGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestSplatContent session_request_splat_content = 27;
   */
  sessionRequestSplatContent?: SessionRequestSplatContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoCutoutsContent session_request_video_cutouts_content = 28;
   */
  sessionRequestVideoCutoutsContent?: SessionRequestVideoCutoutsContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestPromptMusicLyricsStructuredContent session_request_prompt_music_lyrics_structured_content = 29;
   */
  sessionRequestPromptMusicLyricsStructuredContent?: SessionRequestPromptMusicLyricsStructuredContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoTemplateContent session_request_video_template_content = 30;
   */
  sessionRequestVideoTemplateContent?: SessionRequestVideoTemplateContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestVideoEditorContent session_request_video_editor_content = 31;
   */
  sessionRequestVideoEditorContent?: SessionRequestVideoEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestYouTubeThumbnailGeneratorContent session_request_youtube_thumbnail_generator_content = 32;
   */
  sessionRequestYoutubeThumbnailGeneratorContent?: SessionRequestYouTubeThumbnailGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestInpaintContent session_request_inpaint_content = 33;
   */
  sessionRequestInpaintContent?: SessionRequestInpaintContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionRequestAdBannerResizerContent session_request_ad_banner_resizer_content = 34;
   */
  sessionRequestAdBannerResizerContent?: SessionRequestAdBannerResizerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SessionVisibility visibility = 5;
   */
  visibility?: SessionVisibilityJson;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Source source = 26;
   */
  source?: SourceJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InitiateSessionRequest.
 * Use `create(InitiateSessionRequestSchema)` to create a new message.
 */
export const InitiateSessionRequestSchema: GenMessage<InitiateSessionRequest, {jsonType: InitiateSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 68);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateSessionResponse
 */
export type InitiateSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.InitiateSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.Iteration iteration = 2;
   */
  iteration?: Iteration | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateSessionResponse
 */
export type InitiateSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.Iteration iteration = 2;
   */
  iteration?: IterationJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InitiateSessionResponse.
 * Use `create(InitiateSessionResponseSchema)` to create a new message.
 */
export const InitiateSessionResponseSchema: GenMessage<InitiateSessionResponse, {jsonType: InitiateSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 69);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"creativefabrica.studiomediamatrix.v1.ListSessionsRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSessionsRequest
 */
export type ListSessionsRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest, {jsonType: ListSessionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 70);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"creativefabrica.studiomediamatrix.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Session sessions = 1;
   */
  sessions: Session[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListSessionsResponse
 */
export type ListSessionsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Session sessions = 1;
   */
  sessions?: SessionJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse, {jsonType: ListSessionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 71);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMediaItemsRequest
 */
export type ListMediaItemsRequest = Message<"creativefabrica.studiomediamatrix.v1.ListMediaItemsRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMediaItemsRequest
 */
export type ListMediaItemsRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMediaItemsRequest.
 * Use `create(ListMediaItemsRequestSchema)` to create a new message.
 */
export const ListMediaItemsRequestSchema: GenMessage<ListMediaItemsRequest, {jsonType: ListMediaItemsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 72);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMediaItemsResponse
 */
export type ListMediaItemsResponse = Message<"creativefabrica.studiomediamatrix.v1.ListMediaItemsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem items = 1;
   */
  items: MediaItem[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMediaItemsResponse
 */
export type ListMediaItemsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem items = 1;
   */
  items?: MediaItemJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMediaItemsResponse.
 * Use `create(ListMediaItemsResponseSchema)` to create a new message.
 */
export const ListMediaItemsResponseSchema: GenMessage<ListMediaItemsResponse, {jsonType: ListMediaItemsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 73);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionRequest
 */
export type GetSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionRequest
 */
export type GetSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema: GenMessage<GetSessionRequest, {jsonType: GetSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 74);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionResponse
 */
export type GetSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionResponse
 */
export type GetSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema: GenMessage<GetSessionResponse, {jsonType: GetSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 75);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadRequest
 */
export type DownloadRequest = Message<"creativefabrica.studiomediamatrix.v1.DownloadRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.DownloadRequest.download
   */
  download: {
    /**
     * @generated from field: string session_id = 2;
     */
    value: string;
    case: "sessionId";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds image_ids = 3;
     */
    value: DownloadRequest_ImageIds;
    case: "imageIds";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadRequest
 */
export type DownloadRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds image_ids = 3;
   */
  imageIds?: DownloadRequest_ImageIdsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest, {jsonType: DownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 76);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIds = Message<"creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds"> & {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIdsJson = {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DownloadRequest.ImageIds.
 * Use `create(DownloadRequest_ImageIdsSchema)` to create a new message.
 */
export const DownloadRequest_ImageIdsSchema: GenMessage<DownloadRequest_ImageIds, {jsonType: DownloadRequest_ImageIdsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 76, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadResponse
 */
export type DownloadResponse = Message<"creativefabrica.studiomediamatrix.v1.DownloadResponse"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadResponse
 */
export type DownloadResponseJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DownloadResponse.
 * Use `create(DownloadResponseSchema)` to create a new message.
 */
export const DownloadResponseSchema: GenMessage<DownloadResponse, {jsonType: DownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 77);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetDownloadRequest
 */
export type GetDownloadRequest = Message<"creativefabrica.studiomediamatrix.v1.GetDownloadRequest"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetDownloadRequest
 */
export type GetDownloadRequestJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetDownloadRequest.
 * Use `create(GetDownloadRequestSchema)` to create a new message.
 */
export const GetDownloadRequestSchema: GenMessage<GetDownloadRequest, {jsonType: GetDownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 78);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetDownloadResponse
 */
export type GetDownloadResponse = Message<"creativefabrica.studiomediamatrix.v1.GetDownloadResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Download download = 1;
   */
  download?: Download | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetDownloadResponse
 */
export type GetDownloadResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Download download = 1;
   */
  download?: DownloadJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetDownloadResponse.
 * Use `create(GetDownloadResponseSchema)` to create a new message.
 */
export const GetDownloadResponseSchema: GenMessage<GetDownloadResponse, {jsonType: GetDownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 79);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DeleteSessionRequest
 */
export type DeleteSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.DeleteSessionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DeleteSessionRequest
 */
export type DeleteSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DeleteSessionRequest.
 * Use `create(DeleteSessionRequestSchema)` to create a new message.
 */
export const DeleteSessionRequestSchema: GenMessage<DeleteSessionRequest, {jsonType: DeleteSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 80);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DeleteSessionResponse
 */
export type DeleteSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.DeleteSessionResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DeleteSessionResponse
 */
export type DeleteSessionResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DeleteSessionResponse.
 * Use `create(DeleteSessionResponseSchema)` to create a new message.
 */
export const DeleteSessionResponseSchema: GenMessage<DeleteSessionResponse, {jsonType: DeleteSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 81);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PurgeSessionRequest
 */
export type PurgeSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.PurgeSessionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PurgeSessionRequest
 */
export type PurgeSessionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PurgeSessionRequest.
 * Use `create(PurgeSessionRequestSchema)` to create a new message.
 */
export const PurgeSessionRequestSchema: GenMessage<PurgeSessionRequest, {jsonType: PurgeSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 82);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PurgeSessionResponse
 */
export type PurgeSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.PurgeSessionResponse"> & {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted: boolean;

  /**
   * The session's input/output media URLs that were deleted from S3.
   *
   * @generated from field: repeated string deleted_media_urls = 2;
   */
  deletedMediaUrls: string[];

  /**
   * The VOD CloudFront URLs whose cache was invalidated.
   *
   * @generated from field: repeated string invalidated_cdn_urls = 3;
   */
  invalidatedCdnUrls: string[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.PurgeSessionResponse
 */
export type PurgeSessionResponseJson = {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted?: boolean;

  /**
   * The session's input/output media URLs that were deleted from S3.
   *
   * @generated from field: repeated string deleted_media_urls = 2;
   */
  deletedMediaUrls?: string[];

  /**
   * The VOD CloudFront URLs whose cache was invalidated.
   *
   * @generated from field: repeated string invalidated_cdn_urls = 3;
   */
  invalidatedCdnUrls?: string[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.PurgeSessionResponse.
 * Use `create(PurgeSessionResponseSchema)` to create a new message.
 */
export const PurgeSessionResponseSchema: GenMessage<PurgeSessionResponse, {jsonType: PurgeSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 83);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWRequest
 */
export type SetSessionMediaNSFWRequest = Message<"creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: bool is_nsfw = 3;
   */
  isNsfw: boolean;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWRequest
 */
export type SetSessionMediaNSFWRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: bool is_nsfw = 3;
   */
  isNsfw?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWRequest.
 * Use `create(SetSessionMediaNSFWRequestSchema)` to create a new message.
 */
export const SetSessionMediaNSFWRequestSchema: GenMessage<SetSessionMediaNSFWRequest, {jsonType: SetSessionMediaNSFWRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 84);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWResponse
 */
export type SetSessionMediaNSFWResponse = Message<"creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWResponse"> & {
  /**
   * The session's output media after the update; media_items for
   * video/audio/3D tools, images for image tools.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem media_items = 1;
   */
  mediaItems: MediaItem[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 2;
   */
  images: Image[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWResponse
 */
export type SetSessionMediaNSFWResponseJson = {
  /**
   * The session's output media after the update; media_items for
   * video/audio/3D tools, images for image tools.
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MediaItem media_items = 1;
   */
  mediaItems?: MediaItemJson[];

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Image images = 2;
   */
  images?: ImageJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.SetSessionMediaNSFWResponse.
 * Use `create(SetSessionMediaNSFWResponseSchema)` to create a new message.
 */
export const SetSessionMediaNSFWResponseSchema: GenMessage<SetSessionMediaNSFWResponse, {jsonType: SetSessionMediaNSFWResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 85);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateRequest
 */
export type AdminMakeSessionPrivateRequest = Message<"creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateRequest
 */
export type AdminMakeSessionPrivateRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateRequest.
 * Use `create(AdminMakeSessionPrivateRequestSchema)` to create a new message.
 */
export const AdminMakeSessionPrivateRequestSchema: GenMessage<AdminMakeSessionPrivateRequest, {jsonType: AdminMakeSessionPrivateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 86);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateResponse
 */
export type AdminMakeSessionPrivateResponse = Message<"creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateResponse
 */
export type AdminMakeSessionPrivateResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.AdminMakeSessionPrivateResponse.
 * Use `create(AdminMakeSessionPrivateResponseSchema)` to create a new message.
 */
export const AdminMakeSessionPrivateResponseSchema: GenMessage<AdminMakeSessionPrivateResponse, {jsonType: AdminMakeSessionPrivateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 87);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateShareLinkRequest
 */
export type CreateShareLinkRequest = Message<"creativefabrica.studiomediamatrix.v1.CreateShareLinkRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateShareLinkRequest
 */
export type CreateShareLinkRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateShareLinkRequest.
 * Use `create(CreateShareLinkRequestSchema)` to create a new message.
 */
export const CreateShareLinkRequestSchema: GenMessage<CreateShareLinkRequest, {jsonType: CreateShareLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 88);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateShareLinkResponse
 */
export type CreateShareLinkResponse = Message<"creativefabrica.studiomediamatrix.v1.CreateShareLinkResponse"> & {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateShareLinkResponse
 */
export type CreateShareLinkResponseJson = {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateShareLinkResponse.
 * Use `create(CreateShareLinkResponseSchema)` to create a new message.
 */
export const CreateShareLinkResponseSchema: GenMessage<CreateShareLinkResponse, {jsonType: CreateShareLinkResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 89);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetShareLinkRequest
 */
export type GetShareLinkRequest = Message<"creativefabrica.studiomediamatrix.v1.GetShareLinkRequest"> & {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetShareLinkRequest
 */
export type GetShareLinkRequestJson = {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetShareLinkRequest.
 * Use `create(GetShareLinkRequestSchema)` to create a new message.
 */
export const GetShareLinkRequestSchema: GenMessage<GetShareLinkRequest, {jsonType: GetShareLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 90);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetShareLinkResponse
 */
export type GetShareLinkResponse = Message<"creativefabrica.studiomediamatrix.v1.GetShareLinkResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ShareActionType action = 4;
   */
  action: ShareActionType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.GetShareLinkResponse.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.Image image = 5;
     */
    value: Image;
    case: "image";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 6;
     */
    value: MediaItem;
    case: "mediaItem";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ContentWrapper input_content = 7;
   */
  inputContent?: ContentWrapper | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetShareLinkResponse
 */
export type GetShareLinkResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ShareActionType action = 4;
   */
  action?: ShareActionTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Image image = 5;
   */
  image?: ImageJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media_item = 6;
   */
  mediaItem?: MediaItemJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ContentWrapper input_content = 7;
   */
  inputContent?: ContentWrapperJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetShareLinkResponse.
 * Use `create(GetShareLinkResponseSchema)` to create a new message.
 */
export const GetShareLinkResponseSchema: GenMessage<GetShareLinkResponse, {jsonType: GetShareLinkResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 91);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ContentWrapper
 */
export type ContentWrapper = Message<"creativefabrica.studiomediamatrix.v1.ContentWrapper"> & {
  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.ContentWrapper.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
     */
    value: PromptContent;
    case: "promptContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 2;
     */
    value: ImageContent;
    case: "imageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 3;
     */
    value: PromptWithImagesContent;
    case: "promptWithImagesContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent prompt_music_generator_content = 4;
     */
    value: PromptMusicGeneratorContent;
    case: "promptMusicGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 5;
     */
    value: PromptSoundGeneratorContent;
    case: "soundGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 6;
     */
    value: PromptSpeechGeneratorContent;
    case: "speechGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 7;
     */
    value: CollageMakerContent;
    case: "collageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SourceFromImageContent source_from_image_content = 8;
     */
    value: SourceFromImageContent;
    case: "sourceFromImageContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 9;
     */
    value: TextCADContent;
    case: "textCadContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetContent doodle_pet_content = 10;
     */
    value: DoodlePetContent;
    case: "doodlePetContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent coloring_page_maker_content = 11;
     */
    value: ColoringPageMakerContent;
    case: "coloringPageMakerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent prompt_to_video_generator_content = 12;
     */
    value: PromptToVideoGeneratorContent;
    case: "promptToVideoGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteContent wedding_invite_content = 13;
     */
    value: WeddingInviteContent;
    case: "weddingInviteContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.EtsyCoachContent etsy_coach_content = 14;
     */
    value: EtsyCoachContent;
    case: "etsyCoachContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent ai_photo_style_content = 15;
     */
    value: AIPhotoStyleContent;
    case: "aiPhotoStyleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyContent toon_family_content = 16;
     */
    value: ToonFamilyContent;
    case: "toonFamilyContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerContent video_upscaler_content = 17;
     */
    value: VideoUpscalerContent;
    case: "videoUpscalerContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 18;
     */
    value: CameraAngleContent;
    case: "cameraAngleContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 19;
     */
    value: MarketplaceEditorContent;
    case: "marketplaceEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 20;
     */
    value: AISVGGeneratorContent;
    case: "aiSvgGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SplatContent splat_content = 21;
     */
    value: SplatContent;
    case: "splatContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 22;
     */
    value: VideoEditorContent;
    case: "videoEditorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent youtube_thumbnail_generator_content = 23;
     */
    value: YouTubeThumbnailGeneratorContent;
    case: "youtubeThumbnailGeneratorContent";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 24;
     */
    value: InpaintContent;
    case: "inpaintContent";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ContentWrapper
 */
export type ContentWrapperJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptContent prompt_content = 1;
   */
  promptContent?: PromptContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageContent image_content = 2;
   */
  imageContent?: ImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptWithImagesContent prompt_with_images_content = 3;
   */
  promptWithImagesContent?: PromptWithImagesContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptMusicGeneratorContent prompt_music_generator_content = 4;
   */
  promptMusicGeneratorContent?: PromptMusicGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSoundGeneratorContent sound_generator_content = 5;
   */
  soundGeneratorContent?: PromptSoundGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptSpeechGeneratorContent speech_generator_content = 6;
   */
  speechGeneratorContent?: PromptSpeechGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CollageMakerContent collage_maker_content = 7;
   */
  collageMakerContent?: CollageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SourceFromImageContent source_from_image_content = 8;
   */
  sourceFromImageContent?: SourceFromImageContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.TextCADContent text_cad_content = 9;
   */
  textCadContent?: TextCADContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.DoodlePetContent doodle_pet_content = 10;
   */
  doodlePetContent?: DoodlePetContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColoringPageMakerContent coloring_page_maker_content = 11;
   */
  coloringPageMakerContent?: ColoringPageMakerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.PromptToVideoGeneratorContent prompt_to_video_generator_content = 12;
   */
  promptToVideoGeneratorContent?: PromptToVideoGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.WeddingInviteContent wedding_invite_content = 13;
   */
  weddingInviteContent?: WeddingInviteContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.EtsyCoachContent etsy_coach_content = 14;
   */
  etsyCoachContent?: EtsyCoachContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AIPhotoStyleContent ai_photo_style_content = 15;
   */
  aiPhotoStyleContent?: AIPhotoStyleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToonFamilyContent toon_family_content = 16;
   */
  toonFamilyContent?: ToonFamilyContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerContent video_upscaler_content = 17;
   */
  videoUpscalerContent?: VideoUpscalerContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.CameraAngleContent camera_angle_content = 18;
   */
  cameraAngleContent?: CameraAngleContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MarketplaceEditorContent marketplace_editor_content = 19;
   */
  marketplaceEditorContent?: MarketplaceEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.AISVGGeneratorContent ai_svg_generator_content = 20;
   */
  aiSvgGeneratorContent?: AISVGGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SplatContent splat_content = 21;
   */
  splatContent?: SplatContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorContent video_editor_content = 22;
   */
  videoEditorContent?: VideoEditorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorContent youtube_thumbnail_generator_content = 23;
   */
  youtubeThumbnailGeneratorContent?: YouTubeThumbnailGeneratorContentJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintContent inpaint_content = 24;
   */
  inpaintContent?: InpaintContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ContentWrapper.
 * Use `create(ContentWrapperSchema)` to create a new message.
 */
export const ContentWrapperSchema: GenMessage<ContentWrapper, {jsonType: ContentWrapperJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 92);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetServiceConfigRequest
 */
export type GetServiceConfigRequest = Message<"creativefabrica.studiomediamatrix.v1.GetServiceConfigRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetServiceConfigRequest
 */
export type GetServiceConfigRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetServiceConfigRequest.
 * Use `create(GetServiceConfigRequestSchema)` to create a new message.
 */
export const GetServiceConfigRequestSchema: GenMessage<GetServiceConfigRequest, {jsonType: GetServiceConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 93);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetServiceConfigResponse
 */
export type GetServiceConfigResponse = Message<"creativefabrica.studiomediamatrix.v1.GetServiceConfigResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.GetServiceConfigResponse.config
   */
  config: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig speech_generator_config = 2;
     */
    value: SpeechGeneratorConfig;
    case: "speechGeneratorConfig";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetServiceConfigResponse
 */
export type GetServiceConfigResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.SpeechGeneratorConfig speech_generator_config = 2;
   */
  speechGeneratorConfig?: SpeechGeneratorConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetServiceConfigResponse.
 * Use `create(GetServiceConfigResponseSchema)` to create a new message.
 */
export const GetServiceConfigResponseSchema: GenMessage<GetServiceConfigResponse, {jsonType: GetServiceConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 94);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListModelsRequest
 */
export type ListModelsRequest = Message<"creativefabrica.studiomediamatrix.v1.ListModelsRequest"> & {
  /**
   * Required. One of SERVICE_TYPE_VIDEO_GENERATOR, SERVICE_TYPE_VIDEO_DRAFT,
   * SERVICE_TYPE_VIDEO_EDITOR, SERVICE_TYPE_IMAGE_EDITOR,
   * SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR, SERVICE_TYPE_INPAINT,
   * SERVICE_TYPE_VIDEO_UPSCALER or SERVICE_TYPE_AD_BANNER_RESIZER; any other
   * value fails with INVALID_ARGUMENT.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * The product surface the caller renders. Set, the response holds only the
   * models offered on that surface (catalog.surfaces; an empty list means every
   * surface), with the surface's default flagged via ModelEntry.is_default.
   * Unset: every model the service_type offers, none flagged.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 2;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListModelsRequest
 */
export type ListModelsRequestJson = {
  /**
   * Required. One of SERVICE_TYPE_VIDEO_GENERATOR, SERVICE_TYPE_VIDEO_DRAFT,
   * SERVICE_TYPE_VIDEO_EDITOR, SERVICE_TYPE_IMAGE_EDITOR,
   * SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR, SERVICE_TYPE_INPAINT,
   * SERVICE_TYPE_VIDEO_UPSCALER or SERVICE_TYPE_AD_BANNER_RESIZER; any other
   * value fails with INVALID_ARGUMENT.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * The product surface the caller renders. Set, the response holds only the
   * models offered on that surface (catalog.surfaces; an empty list means every
   * surface), with the surface's default flagged via ModelEntry.is_default.
   * Unset: every model the service_type offers, none flagged.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 2;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListModelsRequest.
 * Use `create(ListModelsRequestSchema)` to create a new message.
 */
export const ListModelsRequestSchema: GenMessage<ListModelsRequest, {jsonType: ListModelsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 95);

/**
 * ModelEntry pairs an app model identity with its display metadata.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ModelEntry
 */
export type ModelEntry = Message<"creativefabrica.studiomediamatrix.v1.ModelEntry"> & {
  /**
   * The identity the FE submits back when generating. Which member is set
   * matches the requested service_type. For SERVICE_TYPE_VIDEO_EDITOR the
   * enum names the model_config oneof member to send (see VideoEditorModel).
   *
   * @generated from oneof creativefabrica.studiomediamatrix.v1.ModelEntry.model
   */
  model: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel video_generator_model = 1;
     */
    value: VideoGeneratorModel;
    case: "videoGeneratorModel";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel image_generator_model = 2;
     */
    value: ImageGeneratorModel;
    case: "imageGeneratorModel";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorModel video_editor_model = 3;
     */
    value: VideoEditorModel;
    case: "videoEditorModel";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel video_upscaler_model = 7;
     */
    value: VideoUpscalerModel;
    case: "videoUpscalerModel";
  } | { case: undefined; value?: undefined };

  /**
   * Display metadata and capabilities from services-genai. Coin pricing is
   * capabilities.default_coin_config, forwarded untouched from the genai
   * catalog — dynamic-priced models carry no static amount, use the estimate
   * RPCs for a concrete quote. Capability values (aspect ratios, durations)
   * reflect the genai registry and are informational; request validation
   * stays with this service.
   *
   * @generated from field: creativefabrica.preset.v1.CatalogModel catalog = 4;
   */
  catalog?: CatalogModel | undefined;

  /**
   * Set only for SERVICE_TYPE_INPAINT entries.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintModelDetails inpaint_details = 5;
   */
  inpaintDetails?: InpaintModelDetails | undefined;

  /**
   * proxy_enabled reports whether this model is generally available. Defaults
   * true; specific models opt out (false), letting the FE hide models that
   * are still in preview.
   *
   * @generated from field: bool proxy_enabled = 6;
   */
  proxyEnabled: boolean;

  /**
   * is_default marks the model a client preselects on the requested surface
   * when it has no stronger signal (a user's earlier choice, a deep link). At
   * most one entry per response carries it, and only one that is proxy_enabled
   * and not coming_soon. Never set when the request leaves surface unset.
   *
   * @generated from field: bool is_default = 8;
   */
  isDefault: boolean;

  /**
   * coming_soon marks a pre-launch model the FE shows (and may let users
   * select) but must not submit: InitiateSession rejects it with
   * INVALID_ARGUMENT. Mirrors catalog.coming_soon.
   *
   * @generated from field: bool coming_soon = 9;
   */
  comingSoon: boolean;
};

/**
 * ModelEntry pairs an app model identity with its display metadata.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ModelEntry
 */
export type ModelEntryJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoGeneratorModel video_generator_model = 1;
   */
  videoGeneratorModel?: VideoGeneratorModelJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImageGeneratorModel image_generator_model = 2;
   */
  imageGeneratorModel?: ImageGeneratorModelJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoEditorModel video_editor_model = 3;
   */
  videoEditorModel?: VideoEditorModelJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel video_upscaler_model = 7;
   */
  videoUpscalerModel?: VideoUpscalerModelJson;

  /**
   * Display metadata and capabilities from services-genai. Coin pricing is
   * capabilities.default_coin_config, forwarded untouched from the genai
   * catalog — dynamic-priced models carry no static amount, use the estimate
   * RPCs for a concrete quote. Capability values (aspect ratios, durations)
   * reflect the genai registry and are informational; request validation
   * stays with this service.
   *
   * @generated from field: creativefabrica.preset.v1.CatalogModel catalog = 4;
   */
  catalog?: CatalogModelJson;

  /**
   * Set only for SERVICE_TYPE_INPAINT entries.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.InpaintModelDetails inpaint_details = 5;
   */
  inpaintDetails?: InpaintModelDetailsJson;

  /**
   * proxy_enabled reports whether this model is generally available. Defaults
   * true; specific models opt out (false), letting the FE hide models that
   * are still in preview.
   *
   * @generated from field: bool proxy_enabled = 6;
   */
  proxyEnabled?: boolean;

  /**
   * is_default marks the model a client preselects on the requested surface
   * when it has no stronger signal (a user's earlier choice, a deep link). At
   * most one entry per response carries it, and only one that is proxy_enabled
   * and not coming_soon. Never set when the request leaves surface unset.
   *
   * @generated from field: bool is_default = 8;
   */
  isDefault?: boolean;

  /**
   * coming_soon marks a pre-launch model the FE shows (and may let users
   * select) but must not submit: InitiateSession rejects it with
   * INVALID_ARGUMENT. Mirrors catalog.coming_soon.
   *
   * @generated from field: bool coming_soon = 9;
   */
  comingSoon?: boolean;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ModelEntry.
 * Use `create(ModelEntrySchema)` to create a new message.
 */
export const ModelEntrySchema: GenMessage<ModelEntry, {jsonType: ModelEntryJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 96);

/**
 * Inpaint-specific model configuration surfaced alongside the catalog entry.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintModelDetails
 */
export type InpaintModelDetails = Message<"creativefabrica.studiomediamatrix.v1.InpaintModelDetails"> & {
  /**
   * The scribble colors the FE drawing palette must offer for this model;
   * SessionRequestInpaintContent.scribble_colors entries must reference
   * colors from this list (matched by name).
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 1;
   */
  scribbleColors: InpaintScribbleColor[];
};

/**
 * Inpaint-specific model configuration surfaced alongside the catalog entry.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.InpaintModelDetails
 */
export type InpaintModelDetailsJson = {
  /**
   * The scribble colors the FE drawing palette must offer for this model;
   * SessionRequestInpaintContent.scribble_colors entries must reference
   * colors from this list (matched by name).
   *
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.InpaintScribbleColor scribble_colors = 1;
   */
  scribbleColors?: InpaintScribbleColorJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InpaintModelDetails.
 * Use `create(InpaintModelDetailsSchema)` to create a new message.
 */
export const InpaintModelDetailsSchema: GenMessage<InpaintModelDetails, {jsonType: InpaintModelDetailsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 97);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListModelsResponse
 */
export type ListModelsResponse = Message<"creativefabrica.studiomediamatrix.v1.ListModelsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ModelEntry models = 1;
   */
  models: ModelEntry[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListModelsResponse
 */
export type ListModelsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ModelEntry models = 1;
   */
  models?: ModelEntryJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListModelsResponse.
 * Use `create(ListModelsResponseSchema)` to create a new message.
 */
export const ListModelsResponseSchema: GenMessage<ListModelsResponse, {jsonType: ListModelsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 98);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionRequest
 */
export type InitiateInternalSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.InitiateInternalSessionRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.InitiateInternalSessionRequest.request
   */
  request: {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.InternalRequestImageContent internal_request_image_content = 3;
     */
    value: InternalRequestImageContent;
    case: "internalRequestImageContent";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionRequest
 */
export type InitiateInternalSessionRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.InternalRequestImageContent internal_request_image_content = 3;
   */
  internalRequestImageContent?: InternalRequestImageContentJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionRequest.
 * Use `create(InitiateInternalSessionRequestSchema)` to create a new message.
 */
export const InitiateInternalSessionRequestSchema: GenMessage<InitiateInternalSessionRequest, {jsonType: InitiateInternalSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 99);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionResponse
 */
export type InitiateInternalSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.InitiateInternalSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionResponse
 */
export type InitiateInternalSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.InitiateInternalSessionResponse.
 * Use `create(InitiateInternalSessionResponseSchema)` to create a new message.
 */
export const InitiateInternalSessionResponseSchema: GenMessage<InitiateInternalSessionResponse, {jsonType: InitiateInternalSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 100);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateRequest
 */
export type GetVideoSessionForTemplateRequest = Message<"creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string media_id = 2;
   */
  mediaId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateRequest
 */
export type GetVideoSessionForTemplateRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string media_id = 2;
   */
  mediaId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateRequest.
 * Use `create(GetVideoSessionForTemplateRequestSchema)` to create a new message.
 */
export const GetVideoSessionForTemplateRequestSchema: GenMessage<GetVideoSessionForTemplateRequest, {jsonType: GetVideoSessionForTemplateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 101);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateResponse
 */
export type GetVideoSessionForTemplateResponse = Message<"creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * @generated from field: string duration = 4;
   */
  duration: string;

  /**
   * @generated from field: string resolution = 5;
   */
  resolution: string;

  /**
   * @generated from field: string aspect_ratio = 6;
   */
  aspectRatio: string;

  /**
   * @generated from field: string preview_url = 7;
   */
  previewUrl: string;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateResponse
 */
export type GetVideoSessionForTemplateResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt?: string;

  /**
   * @generated from field: string model = 3;
   */
  model?: string;

  /**
   * @generated from field: string duration = 4;
   */
  duration?: string;

  /**
   * @generated from field: string resolution = 5;
   */
  resolution?: string;

  /**
   * @generated from field: string aspect_ratio = 6;
   */
  aspectRatio?: string;

  /**
   * @generated from field: string preview_url = 7;
   */
  previewUrl?: string;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetVideoSessionForTemplateResponse.
 * Use `create(GetVideoSessionForTemplateResponseSchema)` to create a new message.
 */
export const GetVideoSessionForTemplateResponseSchema: GenMessage<GetVideoSessionForTemplateResponse, {jsonType: GetVideoSessionForTemplateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 102);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteToolRequest
 */
export type FavoriteToolRequest = Message<"creativefabrica.studiomediamatrix.v1.FavoriteToolRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 1;
   */
  tool: ToolType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteToolRequest
 */
export type FavoriteToolRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 1;
   */
  tool?: ToolTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteToolRequest.
 * Use `create(FavoriteToolRequestSchema)` to create a new message.
 */
export const FavoriteToolRequestSchema: GenMessage<FavoriteToolRequest, {jsonType: FavoriteToolRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 103);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteToolResponse
 */
export type FavoriteToolResponse = Message<"creativefabrica.studiomediamatrix.v1.FavoriteToolResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoriteToolResponse
 */
export type FavoriteToolResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoriteToolResponse.
 * Use `create(FavoriteToolResponseSchema)` to create a new message.
 */
export const FavoriteToolResponseSchema: GenMessage<FavoriteToolResponse, {jsonType: FavoriteToolResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 104);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteToolRequest
 */
export type UnfavoriteToolRequest = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteToolRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 1;
   */
  tool: ToolType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteToolRequest
 */
export type UnfavoriteToolRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 1;
   */
  tool?: ToolTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteToolRequest.
 * Use `create(UnfavoriteToolRequestSchema)` to create a new message.
 */
export const UnfavoriteToolRequestSchema: GenMessage<UnfavoriteToolRequest, {jsonType: UnfavoriteToolRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 105);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteToolResponse
 */
export type UnfavoriteToolResponse = Message<"creativefabrica.studiomediamatrix.v1.UnfavoriteToolResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.UnfavoriteToolResponse
 */
export type UnfavoriteToolResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.UnfavoriteToolResponse.
 * Use `create(UnfavoriteToolResponseSchema)` to create a new message.
 */
export const UnfavoriteToolResponseSchema: GenMessage<UnfavoriteToolResponse, {jsonType: UnfavoriteToolResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 106);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsRequest
 */
export type ListFavoriteToolsRequest = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteToolsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsRequest
 */
export type ListFavoriteToolsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsRequest.
 * Use `create(ListFavoriteToolsRequestSchema)` to create a new message.
 */
export const ListFavoriteToolsRequestSchema: GenMessage<ListFavoriteToolsRequest, {jsonType: ListFavoriteToolsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 107);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse
 */
export type ListFavoriteToolsResponse = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool favorites = 1;
   */
  favorites: ListFavoriteToolsResponse_FavoritedTool[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse
 */
export type ListFavoriteToolsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool favorites = 1;
   */
  favorites?: ListFavoriteToolsResponse_FavoritedToolJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.
 * Use `create(ListFavoriteToolsResponseSchema)` to create a new message.
 */
export const ListFavoriteToolsResponseSchema: GenMessage<ListFavoriteToolsResponse, {jsonType: ListFavoriteToolsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 108);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool
 */
export type ListFavoriteToolsResponse_FavoritedTool = Message<"creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 2;
   */
  tool: ToolType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool
 */
export type ListFavoriteToolsResponse_FavoritedToolJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool = 2;
   */
  tool?: ToolTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListFavoriteToolsResponse.FavoritedTool.
 * Use `create(ListFavoriteToolsResponse_FavoritedToolSchema)` to create a new message.
 */
export const ListFavoriteToolsResponse_FavoritedToolSchema: GenMessage<ListFavoriteToolsResponse_FavoritedTool, {jsonType: ListFavoriteToolsResponse_FavoritedToolJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 108, 0);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsRequest
 */
export type ListMostFavoritedToolsRequest = Message<"creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsRequest
 */
export type ListMostFavoritedToolsRequestJson = {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsRequest.
 * Use `create(ListMostFavoritedToolsRequestSchema)` to create a new message.
 */
export const ListMostFavoritedToolsRequestSchema: GenMessage<ListMostFavoritedToolsRequest, {jsonType: ListMostFavoritedToolsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 109);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsResponse
 */
export type ListMostFavoritedToolsResponse = Message<"creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.FavoritedToolCount tools = 1;
   */
  tools: FavoritedToolCount[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsResponse
 */
export type ListMostFavoritedToolsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.FavoritedToolCount tools = 1;
   */
  tools?: FavoritedToolCountJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListMostFavoritedToolsResponse.
 * Use `create(ListMostFavoritedToolsResponseSchema)` to create a new message.
 */
export const ListMostFavoritedToolsResponseSchema: GenMessage<ListMostFavoritedToolsResponse, {jsonType: ListMostFavoritedToolsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 110);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritedToolCount
 */
export type FavoritedToolCount = Message<"creativefabrica.studiomediamatrix.v1.FavoritedToolCount"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool_type = 1;
   */
  toolType: ToolType;

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.FavoritedToolCount
 */
export type FavoritedToolCountJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ToolType tool_type = 1;
   */
  toolType?: ToolTypeJson;

  /**
   * @generated from field: int64 count = 2;
   */
  count?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.FavoritedToolCount.
 * Use `create(FavoritedToolCountSchema)` to create a new message.
 */
export const FavoritedToolCountSchema: GenMessage<FavoritedToolCount, {jsonType: FavoritedToolCountJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 111);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetColorDescriptionRequest
 */
export type GetColorDescriptionRequest = Message<"creativefabrica.studiomediamatrix.v1.GetColorDescriptionRequest"> & {
  /**
   * @generated from field: string hex_color = 1;
   */
  hexColor: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetColorDescriptionRequest
 */
export type GetColorDescriptionRequestJson = {
  /**
   * @generated from field: string hex_color = 1;
   */
  hexColor?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetColorDescriptionRequest.
 * Use `create(GetColorDescriptionRequestSchema)` to create a new message.
 */
export const GetColorDescriptionRequestSchema: GenMessage<GetColorDescriptionRequest, {jsonType: GetColorDescriptionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 112);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetColorDescriptionResponse
 */
export type GetColorDescriptionResponse = Message<"creativefabrica.studiomediamatrix.v1.GetColorDescriptionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColorDescription color_description = 1;
   */
  colorDescription?: ColorDescription | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetColorDescriptionResponse
 */
export type GetColorDescriptionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ColorDescription color_description = 1;
   */
  colorDescription?: ColorDescriptionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetColorDescriptionResponse.
 * Use `create(GetColorDescriptionResponseSchema)` to create a new message.
 */
export const GetColorDescriptionResponseSchema: GenMessage<GetColorDescriptionResponse, {jsonType: GetColorDescriptionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 113);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicMediaRequest
 */
export type GetPublicMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.GetPublicMediaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicMediaRequest
 */
export type GetPublicMediaRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPublicMediaRequest.
 * Use `create(GetPublicMediaRequestSchema)` to create a new message.
 */
export const GetPublicMediaRequestSchema: GenMessage<GetPublicMediaRequest, {jsonType: GetPublicMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 114);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicMediaResponse
 */
export type GetPublicMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.GetPublicMediaResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media = 1;
   */
  media?: MediaItem | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicMediaResponse
 */
export type GetPublicMediaResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.MediaItem media = 1;
   */
  media?: MediaItemJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPublicMediaResponse.
 * Use `create(GetPublicMediaResponseSchema)` to create a new message.
 */
export const GetPublicMediaResponseSchema: GenMessage<GetPublicMediaResponse, {jsonType: GetPublicMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 115);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionForMediaRequest
 */
export type GetSessionForMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.GetSessionForMediaRequest"> & {
  /**
   * @generated from field: string media_id = 1;
   */
  mediaId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionForMediaRequest
 */
export type GetSessionForMediaRequestJson = {
  /**
   * @generated from field: string media_id = 1;
   */
  mediaId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionForMediaRequest.
 * Use `create(GetSessionForMediaRequestSchema)` to create a new message.
 */
export const GetSessionForMediaRequestSchema: GenMessage<GetSessionForMediaRequest, {jsonType: GetSessionForMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 116);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionForMediaResponse
 */
export type GetSessionForMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.GetSessionForMediaResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetSessionForMediaResponse
 */
export type GetSessionForMediaResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetSessionForMediaResponse.
 * Use `create(GetSessionForMediaResponseSchema)` to create a new message.
 */
export const GetSessionForMediaResponseSchema: GenMessage<GetSessionForMediaResponse, {jsonType: GetSessionForMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 117);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicSessionRequest
 */
export type GetPublicSessionRequest = Message<"creativefabrica.studiomediamatrix.v1.GetPublicSessionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType: ServiceType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicSessionRequest
 */
export type GetPublicSessionRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 2;
   */
  serviceType?: ServiceTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPublicSessionRequest.
 * Use `create(GetPublicSessionRequestSchema)` to create a new message.
 */
export const GetPublicSessionRequestSchema: GenMessage<GetPublicSessionRequest, {jsonType: GetPublicSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 118);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicSessionResponse
 */
export type GetPublicSessionResponse = Message<"creativefabrica.studiomediamatrix.v1.GetPublicSessionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.GetPublicSessionResponse
 */
export type GetPublicSessionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.GetPublicSessionResponse.
 * Use `create(GetPublicSessionResponseSchema)` to create a new message.
 */
export const GetPublicSessionResponseSchema: GenMessage<GetPublicSessionResponse, {jsonType: GetPublicSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 119);

/**
 * Payload for ACTION_TYPE_IMPORT_IMAGE.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportImagePayload
 */
export type ImportImagePayload = Message<"creativefabrica.studiomediamatrix.v1.ImportImagePayload"> & {
  /**
   * The image to import. Must resolve to a bucket this service accepts as an
   * image source, under a key owned by the calling user.
   *
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * Which tool produced the image. Optional; without it the round cannot
   * explain where the image came from.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageSource source = 2;
   */
  source?: ImportedImageSource | undefined;
};

/**
 * Payload for ACTION_TYPE_IMPORT_IMAGE.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportImagePayload
 */
export type ImportImagePayloadJson = {
  /**
   * The image to import. Must resolve to a bucket this service accepts as an
   * image source, under a key owned by the calling user.
   *
   * @generated from field: string image_url = 1;
   */
  imageUrl?: string;

  /**
   * Which tool produced the image. Optional; without it the round cannot
   * explain where the image came from.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportedImageSource source = 2;
   */
  source?: ImportedImageSourceJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ImportImagePayload.
 * Use `create(ImportImagePayloadSchema)` to create a new message.
 */
export const ImportImagePayloadSchema: GenMessage<ImportImagePayload, {jsonType: ImportImagePayloadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 120);

/**
 * Result of ACTION_TYPE_IMPORT_IMAGE, so the client can render the new turn
 * without refetching the iteration list.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportImageResult
 */
export type ImportImageResult = Message<"creativefabrica.studiomediamatrix.v1.ImportImageResult"> & {
  /**
   * @generated from field: string iteration_id = 1;
   */
  iterationId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * The imported image, copied into the session's own storage.
   *
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;
};

/**
 * Result of ACTION_TYPE_IMPORT_IMAGE, so the client can render the new turn
 * without refetching the iteration list.
 *
 * @generated from message creativefabrica.studiomediamatrix.v1.ImportImageResult
 */
export type ImportImageResultJson = {
  /**
   * @generated from field: string iteration_id = 1;
   */
  iterationId?: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId?: string;

  /**
   * The imported image, copied into the session's own storage.
   *
   * @generated from field: string image_url = 3;
   */
  imageUrl?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ImportImageResult.
 * Use `create(ImportImageResultSchema)` to create a new message.
 */
export const ImportImageResultSchema: GenMessage<ImportImageResult, {jsonType: ImportImageResultJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 121);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateActionRequest
 */
export type CreateActionRequest = Message<"creativefabrica.studiomediamatrix.v1.CreateActionRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType action_type = 4;
   */
  actionType: ActionType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.CreateActionRequest.action_payload
   */
  actionPayload: {
    /**
     * @generated from field: string iteration_id = 5;
     */
    value: string;
    case: "iterationId";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImportImagePayload import_image = 6;
     */
    value: ImportImagePayload;
    case: "importImage";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateActionRequest
 */
export type CreateActionRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType action_type = 4;
   */
  actionType?: ActionTypeJson;

  /**
   * @generated from field: string iteration_id = 5;
   */
  iterationId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportImagePayload import_image = 6;
   */
  importImage?: ImportImagePayloadJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateActionRequest.
 * Use `create(CreateActionRequestSchema)` to create a new message.
 */
export const CreateActionRequestSchema: GenMessage<CreateActionRequest, {jsonType: CreateActionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 122);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateActionResponse
 */
export type CreateActionResponse = Message<"creativefabrica.studiomediamatrix.v1.CreateActionResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType action_type = 1;
   */
  actionType: ActionType;

  /**
   * @generated from oneof creativefabrica.studiomediamatrix.v1.CreateActionResponse.action_payload_response
   */
  actionPayloadResponse: {
    /**
     * @generated from field: string new_session_id = 2;
     */
    value: string;
    case: "newSessionId";
  } | {
    /**
     * @generated from field: creativefabrica.studiomediamatrix.v1.ImportImageResult import_image = 3;
     */
    value: ImportImageResult;
    case: "importImage";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.CreateActionResponse
 */
export type CreateActionResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ActionType action_type = 1;
   */
  actionType?: ActionTypeJson;

  /**
   * @generated from field: string new_session_id = 2;
   */
  newSessionId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ImportImageResult import_image = 3;
   */
  importImage?: ImportImageResultJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.CreateActionResponse.
 * Use `create(CreateActionResponseSchema)` to create a new message.
 */
export const CreateActionResponseSchema: GenMessage<CreateActionResponse, {jsonType: CreateActionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 123);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListNoticesRequest
 */
export type ListNoticesRequest = Message<"creativefabrica.studiomediamatrix.v1.ListNoticesRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: string object_type = 2;
   */
  objectType: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListNoticesRequest
 */
export type ListNoticesRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: string object_type = 2;
   */
  objectType?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListNoticesRequest.
 * Use `create(ListNoticesRequestSchema)` to create a new message.
 */
export const ListNoticesRequestSchema: GenMessage<ListNoticesRequest, {jsonType: ListNoticesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 124);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListNoticesResponse
 */
export type ListNoticesResponse = Message<"creativefabrica.studiomediamatrix.v1.ListNoticesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Notice notices = 1;
   */
  notices: Notice[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: int32 unviewed_count = 3;
   */
  unviewedCount: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.ListNoticesResponse
 */
export type ListNoticesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.Notice notices = 1;
   */
  notices?: NoticeJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: int32 unviewed_count = 3;
   */
  unviewedCount?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.ListNoticesResponse.
 * Use `create(ListNoticesResponseSchema)` to create a new message.
 */
export const ListNoticesResponseSchema: GenMessage<ListNoticesResponse, {jsonType: ListNoticesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 125);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeActionRequest
 */
export type NoticeActionRequest = Message<"creativefabrica.studiomediamatrix.v1.NoticeActionRequest"> & {
  /**
   * @generated from field: string notice_id = 1;
   */
  noticeId: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeActionType action_type = 2;
   */
  actionType: NoticeActionType;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeActionRequest
 */
export type NoticeActionRequestJson = {
  /**
   * @generated from field: string notice_id = 1;
   */
  noticeId?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.NoticeActionType action_type = 2;
   */
  actionType?: NoticeActionTypeJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.NoticeActionRequest.
 * Use `create(NoticeActionRequestSchema)` to create a new message.
 */
export const NoticeActionRequestSchema: GenMessage<NoticeActionRequest, {jsonType: NoticeActionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 126);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeActionResponse
 */
export type NoticeActionResponse = Message<"creativefabrica.studiomediamatrix.v1.NoticeActionResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.NoticeActionResponse
 */
export type NoticeActionResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.NoticeActionResponse.
 * Use `create(NoticeActionResponseSchema)` to create a new message.
 */
export const NoticeActionResponseSchema: GenMessage<NoticeActionResponse, {jsonType: NoticeActionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 127);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostRequest
 */
export type EstimateVideoUpscaleCostRequest = Message<"creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostRequest"> & {
  /**
   * @generated from field: int32 source_width = 1;
   */
  sourceWidth: number;

  /**
   * @generated from field: int32 source_height = 2;
   */
  sourceHeight: number;

  /**
   * @generated from field: string source_container = 3;
   */
  sourceContainer: string;

  /**
   * @generated from field: int32 source_size = 4;
   */
  sourceSize: number;

  /**
   * @generated from field: double source_duration = 5;
   */
  sourceDuration: number;

  /**
   * @generated from field: double source_frame_rate = 6;
   */
  sourceFrameRate: number;

  /**
   * @generated from field: int32 source_frame_count = 7;
   */
  sourceFrameCount: number;

  /**
   * @generated from field: int32 output_width = 8;
   */
  outputWidth: number;

  /**
   * @generated from field: int32 output_height = 9;
   */
  outputHeight: number;

  /**
   * @generated from field: double output_frame_rate = 10;
   */
  outputFrameRate: number;

  /**
   * @generated from field: string output_container = 11;
   */
  outputContainer: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 12;
   */
  model: VideoUpscalerModel;

  /**
   * Required semantics for the byteplus video-enhance models: the quote
   * depends on the requested resolution tier and fps bucket. Ignored for the
   * Topaz models.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 13;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfig | undefined;

  /**
   * Semantics for the FLUX Video Upscale model: the quote depends on the
   * upscale factor and the creativity mode. Ignored for the other models.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 14;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfig | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostRequest
 */
export type EstimateVideoUpscaleCostRequestJson = {
  /**
   * @generated from field: int32 source_width = 1;
   */
  sourceWidth?: number;

  /**
   * @generated from field: int32 source_height = 2;
   */
  sourceHeight?: number;

  /**
   * @generated from field: string source_container = 3;
   */
  sourceContainer?: string;

  /**
   * @generated from field: int32 source_size = 4;
   */
  sourceSize?: number;

  /**
   * @generated from field: double source_duration = 5;
   */
  sourceDuration?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double source_frame_rate = 6;
   */
  sourceFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 source_frame_count = 7;
   */
  sourceFrameCount?: number;

  /**
   * @generated from field: int32 output_width = 8;
   */
  outputWidth?: number;

  /**
   * @generated from field: int32 output_height = 9;
   */
  outputHeight?: number;

  /**
   * @generated from field: double output_frame_rate = 10;
   */
  outputFrameRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string output_container = 11;
   */
  outputContainer?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerModel model = 12;
   */
  model?: VideoUpscalerModelJson;

  /**
   * Required semantics for the byteplus video-enhance models: the quote
   * depends on the requested resolution tier and fps bucket. Ignored for the
   * Topaz models.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerByteplusEnhanceConfig byteplus_enhance_config = 13;
   */
  byteplusEnhanceConfig?: VideoUpscalerByteplusEnhanceConfigJson;

  /**
   * Semantics for the FLUX Video Upscale model: the quote depends on the
   * upscale factor and the creativity mode. Ignored for the other models.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.VideoUpscalerFluxVideoUpscaleConfig flux_video_upscale_config = 14;
   */
  fluxVideoUpscaleConfig?: VideoUpscalerFluxVideoUpscaleConfigJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostRequest.
 * Use `create(EstimateVideoUpscaleCostRequestSchema)` to create a new message.
 */
export const EstimateVideoUpscaleCostRequestSchema: GenMessage<EstimateVideoUpscaleCostRequest, {jsonType: EstimateVideoUpscaleCostRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 128);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostResponse
 */
export type EstimateVideoUpscaleCostResponse = Message<"creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostResponse"> & {
  /**
   * @generated from field: int64 estimated_cost_coins = 1;
   */
  estimatedCostCoins: bigint;

  /**
   * @generated from field: int64 estimated_time_seconds = 2;
   */
  estimatedTimeSeconds: bigint;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostResponse
 */
export type EstimateVideoUpscaleCostResponseJson = {
  /**
   * @generated from field: int64 estimated_cost_coins = 1;
   */
  estimatedCostCoins?: string;

  /**
   * @generated from field: int64 estimated_time_seconds = 2;
   */
  estimatedTimeSeconds?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.EstimateVideoUpscaleCostResponse.
 * Use `create(EstimateVideoUpscaleCostResponseSchema)` to create a new message.
 */
export const EstimateVideoUpscaleCostResponseSchema: GenMessage<EstimateVideoUpscaleCostResponse, {jsonType: EstimateVideoUpscaleCostResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 129);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostRequest
 */
export type EstimateVideoCutoutsBgrCostRequest = Message<"creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostRequest"> & {
  /**
   * @generated from field: int32 video_width = 1;
   */
  videoWidth: number;

  /**
   * @generated from field: int32 video_height = 2;
   */
  videoHeight: number;

  /**
   * When 0 (not provided), the server returns the maximum allowed frame count for the given resolution.
   *
   * @generated from field: int32 frame_count = 3;
   */
  frameCount: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostRequest
 */
export type EstimateVideoCutoutsBgrCostRequestJson = {
  /**
   * @generated from field: int32 video_width = 1;
   */
  videoWidth?: number;

  /**
   * @generated from field: int32 video_height = 2;
   */
  videoHeight?: number;

  /**
   * When 0 (not provided), the server returns the maximum allowed frame count for the given resolution.
   *
   * @generated from field: int32 frame_count = 3;
   */
  frameCount?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostRequest.
 * Use `create(EstimateVideoCutoutsBgrCostRequestSchema)` to create a new message.
 */
export const EstimateVideoCutoutsBgrCostRequestSchema: GenMessage<EstimateVideoCutoutsBgrCostRequest, {jsonType: EstimateVideoCutoutsBgrCostRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 130);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostResponse
 */
export type EstimateVideoCutoutsBgrCostResponse = Message<"creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostResponse"> & {
  /**
   * @generated from field: int64 estimated_cost_coins = 1;
   */
  estimatedCostCoins: bigint;

  /**
   * @generated from field: int32 effective_frame_count = 2;
   */
  effectiveFrameCount: number;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostResponse
 */
export type EstimateVideoCutoutsBgrCostResponseJson = {
  /**
   * @generated from field: int64 estimated_cost_coins = 1;
   */
  estimatedCostCoins?: string;

  /**
   * @generated from field: int32 effective_frame_count = 2;
   */
  effectiveFrameCount?: number;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.EstimateVideoCutoutsBgrCostResponse.
 * Use `create(EstimateVideoCutoutsBgrCostResponseSchema)` to create a new message.
 */
export const EstimateVideoCutoutsBgrCostResponseSchema: GenMessage<EstimateVideoCutoutsBgrCostResponse, {jsonType: EstimateVideoCutoutsBgrCostResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 131);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TipMediaRequest
 */
export type TipMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.TipMediaRequest"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType: ServiceType;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId: string;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TipMediaRequest
 */
export type TipMediaRequestJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.ServiceType service_type = 1;
   */
  serviceType?: ServiceTypeJson;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId?: string;

  /**
   * @generated from field: string media_id = 3;
   */
  mediaId?: string;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.TipMediaRequest.
 * Use `create(TipMediaRequestSchema)` to create a new message.
 */
export const TipMediaRequestSchema: GenMessage<TipMediaRequest, {jsonType: TipMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 132);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TipMediaResponse
 */
export type TipMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.TipMediaResponse"> & {
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.TipMediaResponse
 */
export type TipMediaResponseJson = {
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.TipMediaResponse.
 * Use `create(TipMediaResponseSchema)` to create a new message.
 */
export const TipMediaResponseSchema: GenMessage<TipMediaResponse, {jsonType: TipMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 133);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsRequest
 */
export type StructureMusicLyricsRequest = Message<"creativefabrica.studiomediamatrix.v1.StructureMusicLyricsRequest"> & {
  /**
   * @generated from field: string idea = 1;
   */
  idea: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 2;
   */
  seedSections: MusicGeneratorSection[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 3;
   */
  targetDurationMs?: number | undefined;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 4;
   */
  songSettings?: MusicGeneratorSongSettings | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsRequest
 */
export type StructureMusicLyricsRequestJson = {
  /**
   * @generated from field: string idea = 1;
   */
  idea?: string;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection seed_sections = 2;
   */
  seedSections?: MusicGeneratorSectionJson[];

  /**
   * @generated from field: optional uint32 target_duration_ms = 3;
   */
  targetDurationMs?: number;

  /**
   * @generated from field: optional creativefabrica.studiomediamatrix.v1.MusicGeneratorSongSettings song_settings = 4;
   */
  songSettings?: MusicGeneratorSongSettingsJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsRequest.
 * Use `create(StructureMusicLyricsRequestSchema)` to create a new message.
 */
export const StructureMusicLyricsRequestSchema: GenMessage<StructureMusicLyricsRequest, {jsonType: StructureMusicLyricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 134);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsResponse
 */
export type StructureMusicLyricsResponse = Message<"creativefabrica.studiomediamatrix.v1.StructureMusicLyricsResponse"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: uint32 total_duration_ms = 2;
   */
  totalDurationMs: number;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 3;
   */
  sections: MusicGeneratorSection[];
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsResponse
 */
export type StructureMusicLyricsResponseJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: uint32 total_duration_ms = 2;
   */
  totalDurationMs?: number;

  /**
   * @generated from field: repeated creativefabrica.studiomediamatrix.v1.MusicGeneratorSection sections = 3;
   */
  sections?: MusicGeneratorSectionJson[];
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.StructureMusicLyricsResponse.
 * Use `create(StructureMusicLyricsResponseSchema)` to create a new message.
 */
export const StructureMusicLyricsResponseSchema: GenMessage<StructureMusicLyricsResponse, {jsonType: StructureMusicLyricsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 135);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaRequest
 */
export type DownloadBrandedMediaRequest = Message<"creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaRequest"> & {
  /**
   * @generated from field: string input_url = 1;
   */
  inputUrl: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaType media_type = 2;
   */
  mediaType: BrandedMediaType;

  /**
   * metadata carries per-type branding parameters and optional overrides.
   * The service auto-detects shape (e.g. aspect ratio for video) from the
   * input itself; metadata is only needed to override that detection or to
   * pass type-specific options. Recognised keys today:
   *   "aspect_ratio" — optional override, e.g. "16x9", "9x16", "1x1"
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };

  /**
   * Platform selects which branding (outro) set is applied.
   * UNSPECIFIED is treated as STUDIO for backward compatibility.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform platform = 4;
   */
  platform: BrandedMediaPlatform;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaRequest
 */
export type DownloadBrandedMediaRequestJson = {
  /**
   * @generated from field: string input_url = 1;
   */
  inputUrl?: string;

  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaType media_type = 2;
   */
  mediaType?: BrandedMediaTypeJson;

  /**
   * metadata carries per-type branding parameters and optional overrides.
   * The service auto-detects shape (e.g. aspect ratio for video) from the
   * input itself; metadata is only needed to override that detection or to
   * pass type-specific options. Recognised keys today:
   *   "aspect_ratio" — optional override, e.g. "16x9", "9x16", "1x1"
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata?: { [key: string]: string };

  /**
   * Platform selects which branding (outro) set is applied.
   * UNSPECIFIED is treated as STUDIO for backward compatibility.
   *
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMediaPlatform platform = 4;
   */
  platform?: BrandedMediaPlatformJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaRequest.
 * Use `create(DownloadBrandedMediaRequestSchema)` to create a new message.
 */
export const DownloadBrandedMediaRequestSchema: GenMessage<DownloadBrandedMediaRequest, {jsonType: DownloadBrandedMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 136);

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaResponse
 */
export type DownloadBrandedMediaResponse = Message<"creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaResponse"> & {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMedia branded_media = 1;
   */
  brandedMedia?: BrandedMedia | undefined;
};

/**
 * @generated from message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaResponse
 */
export type DownloadBrandedMediaResponseJson = {
  /**
   * @generated from field: creativefabrica.studiomediamatrix.v1.BrandedMedia branded_media = 1;
   */
  brandedMedia?: BrandedMediaJson;
};

/**
 * Describes the message creativefabrica.studiomediamatrix.v1.DownloadBrandedMediaResponse.
 * Use `create(DownloadBrandedMediaResponseSchema)` to create a new message.
 */
export const DownloadBrandedMediaResponseSchema: GenMessage<DownloadBrandedMediaResponse, {jsonType: DownloadBrandedMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studiomediamatrix_v1_service, 137);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService
 */
export const StudioMediaMatrixService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.InitiateSession
   */
  initiateSession: {
    methodKind: "unary";
    input: typeof InitiateSessionRequestSchema;
    output: typeof InitiateSessionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.IterateSession
   */
  iterateSession: {
    methodKind: "unary";
    input: typeof IterateSessionRequestSchema;
    output: typeof IterateSessionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListMediaItems
   */
  listMediaItems: {
    methodKind: "unary";
    input: typeof ListMediaItemsRequestSchema;
    output: typeof ListMediaItemsResponseSchema;
  },
  /**
   * GetSession retrieves a session by its ID.
   * Missing the media content in order to avoid unnecessary look up for payloads.
   * If media content is needed, use GetSessionMedia rpc.
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSession
   */
  getSession: {
    methodKind: "unary";
    input: typeof GetSessionRequestSchema;
    output: typeof GetSessionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionIterations
   */
  getSessionIterations: {
    methodKind: "unary";
    input: typeof GetSessionIterationsRequestSchema;
    output: typeof GetSessionIterationsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionImages
   */
  getSessionImages: {
    methodKind: "unary";
    input: typeof GetSessionImagesRequestSchema;
    output: typeof GetSessionImagesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.Download
   */
  download: {
    methodKind: "unary";
    input: typeof DownloadRequestSchema;
    output: typeof DownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetDownload
   */
  getDownload: {
    methodKind: "unary";
    input: typeof GetDownloadRequestSchema;
    output: typeof GetDownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.DeleteSession
   */
  deleteSession: {
    methodKind: "unary";
    input: typeof DeleteSessionRequestSchema;
    output: typeof DeleteSessionResponseSchema;
  },
  /**
   * PurgeSession is a Creative Fabrica staff-only takedown: it marks the session
   * private, soft-deletes it, deletes its S3 input/output media, and invalidates
   * the VOD CloudFront cache for the removed objects. Authorization is enforced by
   * the service (caller's email must be @creativefabrica.com).
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.PurgeSession
   */
  purgeSession: {
    methodKind: "unary";
    input: typeof PurgeSessionRequestSchema;
    output: typeof PurgeSessionResponseSchema;
  },
  /**
   * SetSessionMediaNSFW is a Creative Fabrica staff-only moderation action: it
   * sets or clears the NSFW flag on the session's output media — images and
   * video media items (other media types have no NSFW flag) — and returns the
   * session's output media after the update. It does not change the session's
   * visibility. Authorization is enforced by the service (caller's email must
   * be @creativefabrica.com).
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.SetSessionMediaNSFW
   */
  setSessionMediaNSFW: {
    methodKind: "unary";
    input: typeof SetSessionMediaNSFWRequestSchema;
    output: typeof SetSessionMediaNSFWResponseSchema;
  },
  /**
   * AdminMakeSessionPrivate is a Creative Fabrica staff-only moderation action:
   * it makes a public session private and returns the session. A session that
   * is already private, or locked to private, is returned unchanged. The owner
   * is not notified and keeps the ability to make the session public again.
   * Authorization is enforced by the service (caller's email must be
   * @creativefabrica.com).
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.AdminMakeSessionPrivate
   */
  adminMakeSessionPrivate: {
    methodKind: "unary";
    input: typeof AdminMakeSessionPrivateRequestSchema;
    output: typeof AdminMakeSessionPrivateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionMedia
   */
  getSessionMedia: {
    methodKind: "unary";
    input: typeof GetSessionMediaRequestSchema;
    output: typeof GetSessionMediaResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionInputMedia
   */
  getSessionInputMedia: {
    methodKind: "unary";
    input: typeof GetSessionInputMediaRequestSchema;
    output: typeof GetSessionInputMediaResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UpdateSession
   */
  updateSession: {
    methodKind: "unary";
    input: typeof UpdateSessionRequestSchema;
    output: typeof UpdateSessionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.CreateShareLink
   */
  createShareLink: {
    methodKind: "unary";
    input: typeof CreateShareLinkRequestSchema;
    output: typeof CreateShareLinkResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetShareLink
   */
  getShareLink: {
    methodKind: "unary";
    input: typeof GetShareLinkRequestSchema;
    output: typeof GetShareLinkResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetServiceConfig
   */
  getServiceConfig: {
    methodKind: "unary";
    input: typeof GetServiceConfigRequestSchema;
    output: typeof GetServiceConfigResponseSchema;
  },
  /**
   * ListModels lists the models available for one app (service_type) with
   * display metadata and capabilities sourced from services-genai's
   * AIProviderService catalog. SERVICE_TYPE_VIDEO_GENERATOR,
   * SERVICE_TYPE_VIDEO_EDITOR, SERVICE_TYPE_IMAGE_EDITOR and
   * SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR are supported;
   * any other service_type fails with INVALID_ARGUMENT.
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListModels
   */
  listModels: {
    methodKind: "unary";
    input: typeof ListModelsRequestSchema;
    output: typeof ListModelsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.FavoriteTool
   */
  favoriteTool: {
    methodKind: "unary";
    input: typeof FavoriteToolRequestSchema;
    output: typeof FavoriteToolResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UnfavoriteTool
   */
  unfavoriteTool: {
    methodKind: "unary";
    input: typeof UnfavoriteToolRequestSchema;
    output: typeof UnfavoriteToolResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListFavoriteTools
   */
  listFavoriteTools: {
    methodKind: "unary";
    input: typeof ListFavoriteToolsRequestSchema;
    output: typeof ListFavoriteToolsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListMostFavoritedTools
   */
  listMostFavoritedTools: {
    methodKind: "unary";
    input: typeof ListMostFavoritedToolsRequestSchema;
    output: typeof ListMostFavoritedToolsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetColorDescription
   */
  getColorDescription: {
    methodKind: "unary";
    input: typeof GetColorDescriptionRequestSchema;
    output: typeof GetColorDescriptionResponseSchema;
  },
  /**
   * GetPublicMedia means that a user does not have to be logged in, this will be used by share endpoints.
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetPublicMedia
   */
  getPublicMedia: {
    methodKind: "unary";
    input: typeof GetPublicMediaRequestSchema;
    output: typeof GetPublicMediaResponseSchema;
  },
  /**
   * GetPublicMedia means that a user does not have to be logged in, this will be used by share endpoints.
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetPublicSession
   */
  getPublicSession: {
    methodKind: "unary";
    input: typeof GetPublicSessionRequestSchema;
    output: typeof GetPublicSessionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionForMedia
   */
  getSessionForMedia: {
    methodKind: "unary";
    input: typeof GetSessionForMediaRequestSchema;
    output: typeof GetSessionForMediaResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.CreateAction
   */
  createAction: {
    methodKind: "unary";
    input: typeof CreateActionRequestSchema;
    output: typeof CreateActionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UpdateSessionMediaItem
   */
  updateSessionMediaItem: {
    methodKind: "unary";
    input: typeof UpdateSessionMediaItemRequestSchema;
    output: typeof UpdateSessionMediaItemResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.EstimateVideoUpscaleCost
   */
  estimateVideoUpscaleCost: {
    methodKind: "unary";
    input: typeof EstimateVideoUpscaleCostRequestSchema;
    output: typeof EstimateVideoUpscaleCostResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.EstimateVideoCutoutsBgrCost
   */
  estimateVideoCutoutsBgrCost: {
    methodKind: "unary";
    input: typeof EstimateVideoCutoutsBgrCostRequestSchema;
    output: typeof EstimateVideoCutoutsBgrCostResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.TipMedia
   */
  tipMedia: {
    methodKind: "unary";
    input: typeof TipMediaRequestSchema;
    output: typeof TipMediaResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.StructureMusicLyrics
   */
  structureMusicLyrics: {
    methodKind: "unary";
    input: typeof StructureMusicLyricsRequestSchema;
    output: typeof StructureMusicLyricsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 0);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.InternalMediaMatrixService
 */
export const InternalMediaMatrixService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.InternalMediaMatrixService.InitiateInternalSession
   */
  initiateInternalSession: {
    methodKind: "unary";
    input: typeof InitiateInternalSessionRequestSchema;
    output: typeof InitiateInternalSessionResponseSchema;
  },
  /**
   * GetVideoSessionForTemplate loads one video without a workspace check.
   * Service key only. The caller compares user_id with the curator.
   *
   * @generated from rpc creativefabrica.studiomediamatrix.v1.InternalMediaMatrixService.GetVideoSessionForTemplate
   */
  getVideoSessionForTemplate: {
    methodKind: "unary";
    input: typeof GetVideoSessionForTemplateRequestSchema;
    output: typeof GetVideoSessionForTemplateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 1);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.NoticeService
 */
export const NoticeService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.NoticeService.ListNotices
   */
  listNotices: {
    methodKind: "unary";
    input: typeof ListNoticesRequestSchema;
    output: typeof ListNoticesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.NoticeService.NoticeAction
   */
  noticeAction: {
    methodKind: "unary";
    input: typeof NoticeActionRequestSchema;
    output: typeof NoticeActionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 2);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService
 */
export const AIMockupGeneratorTemplateService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.ListMockupGeneratorTemplates
   */
  listMockupGeneratorTemplates: {
    methodKind: "unary";
    input: typeof ListMockupGeneratorTemplatesRequestSchema;
    output: typeof ListMockupGeneratorTemplatesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.GetMockupGeneratorTemplate
   */
  getMockupGeneratorTemplate: {
    methodKind: "unary";
    input: typeof GetMockupGeneratorTemplateRequestSchema;
    output: typeof GetMockupGeneratorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.FavoriteMockupGeneratorTemplate
   */
  favoriteMockupGeneratorTemplate: {
    methodKind: "unary";
    input: typeof FavoriteMockupGeneratorTemplateRequestSchema;
    output: typeof FavoriteMockupGeneratorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.UnfavoriteMockupGeneratorTemplate
   */
  unfavoriteMockupGeneratorTemplate: {
    methodKind: "unary";
    input: typeof UnfavoriteMockupGeneratorTemplateRequestSchema;
    output: typeof UnfavoriteMockupGeneratorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.ListFavoriteMockupGeneratorTemplates
   */
  listFavoriteMockupGeneratorTemplates: {
    methodKind: "unary";
    input: typeof ListFavoriteMockupGeneratorTemplatesRequestSchema;
    output: typeof ListFavoriteMockupGeneratorTemplatesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.CreateMockupCreatorTemplate
   */
  createMockupCreatorTemplate: {
    methodKind: "unary";
    input: typeof CreateMockupCreatorTemplateRequestSchema;
    output: typeof CreateMockupCreatorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.UpdateMockupCreatorTemplate
   */
  updateMockupCreatorTemplate: {
    methodKind: "unary";
    input: typeof UpdateMockupCreatorTemplateRequestSchema;
    output: typeof UpdateMockupCreatorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.PublishMockupCreatorTemplate
   */
  publishMockupCreatorTemplate: {
    methodKind: "unary";
    input: typeof PublishMockupCreatorTemplateRequestSchema;
    output: typeof PublishMockupCreatorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.GenerateFromMockupCreatorTemplate
   */
  generateFromMockupCreatorTemplate: {
    methodKind: "unary";
    input: typeof GenerateFromMockupCreatorTemplateRequestSchema;
    output: typeof GenerateFromMockupCreatorTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIMockupGeneratorTemplateService.ListMockupCreatorTemplates
   */
  listMockupCreatorTemplates: {
    methodKind: "unary";
    input: typeof ListMockupCreatorTemplatesRequestSchema;
    output: typeof ListMockupCreatorTemplatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 3);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.VideoGeneratorService
 */
export const VideoGeneratorService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.VideoGeneratorService.ListVideoGeneratorTemplates
   */
  listVideoGeneratorTemplates: {
    methodKind: "unary";
    input: typeof ListVideoGeneratorTemplatesRequestSchema;
    output: typeof ListVideoGeneratorTemplatesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.VideoGeneratorService.GetVideoGeneratorTemplate
   */
  getVideoGeneratorTemplate: {
    methodKind: "unary";
    input: typeof GetVideoGeneratorTemplateRequestSchema;
    output: typeof GetVideoGeneratorTemplateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 4);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.AIPhotoStyleService
 */
export const AIPhotoStyleService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIPhotoStyleService.FavoritePhotoStyle
   */
  favoritePhotoStyle: {
    methodKind: "unary";
    input: typeof FavoritePhotoStyleRequestSchema;
    output: typeof FavoritePhotoStyleResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIPhotoStyleService.UnfavoritePhotoStyle
   */
  unfavoritePhotoStyle: {
    methodKind: "unary";
    input: typeof UnfavoritePhotoStyleRequestSchema;
    output: typeof UnfavoritePhotoStyleResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIPhotoStyleService.ListFavoritePhotoStyles
   */
  listFavoritePhotoStyles: {
    methodKind: "unary";
    input: typeof ListFavoritePhotoStylesRequestSchema;
    output: typeof ListFavoritePhotoStylesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIPhotoStyleService.ListPhotoStyles
   */
  listPhotoStyles: {
    methodKind: "unary";
    input: typeof ListPhotoStylesRequestSchema;
    output: typeof ListPhotoStylesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.AIPhotoStyleService.GetPhotoStyle
   */
  getPhotoStyle: {
    methodKind: "unary";
    input: typeof GetPhotoStyleRequestSchema;
    output: typeof GetPhotoStyleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 5);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService
 */
export const YouTubeThumbnailGeneratorService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService.ListYouTubeThumbnailTemplates
   */
  listYouTubeThumbnailTemplates: {
    methodKind: "unary";
    input: typeof ListYouTubeThumbnailTemplatesRequestSchema;
    output: typeof ListYouTubeThumbnailTemplatesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService.GetYouTubeThumbnailTemplate
   */
  getYouTubeThumbnailTemplate: {
    methodKind: "unary";
    input: typeof GetYouTubeThumbnailTemplateRequestSchema;
    output: typeof GetYouTubeThumbnailTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService.FavoriteYouTubeThumbnailTemplate
   */
  favoriteYouTubeThumbnailTemplate: {
    methodKind: "unary";
    input: typeof FavoriteYouTubeThumbnailTemplateRequestSchema;
    output: typeof FavoriteYouTubeThumbnailTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService.UnfavoriteYouTubeThumbnailTemplate
   */
  unfavoriteYouTubeThumbnailTemplate: {
    methodKind: "unary";
    input: typeof UnfavoriteYouTubeThumbnailTemplateRequestSchema;
    output: typeof UnfavoriteYouTubeThumbnailTemplateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.YouTubeThumbnailGeneratorService.ListFavoriteYouTubeThumbnailTemplates
   */
  listFavoriteYouTubeThumbnailTemplates: {
    methodKind: "unary";
    input: typeof ListFavoriteYouTubeThumbnailTemplatesRequestSchema;
    output: typeof ListFavoriteYouTubeThumbnailTemplatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 6);

/**
 * VoicesService serves the speech voice catalog: a paginated, filterable
 * voice list backing the voice picker, plus the filter taxonomies it offers.
 * Both are computed from a locally held snapshot of the vendor catalog, so
 * list filtering and the option values can never disagree.
 *
 * @generated from service creativefabrica.studiomediamatrix.v1.VoicesService
 */
export const VoicesService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.VoicesService.ListSpeechVoices
   */
  listSpeechVoices: {
    methodKind: "unary";
    input: typeof ListSpeechVoicesRequestSchema;
    output: typeof ListSpeechVoicesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.VoicesService.GetSpeechVoiceFilterOptions
   */
  getSpeechVoiceFilterOptions: {
    methodKind: "unary";
    input: typeof GetSpeechVoiceFilterOptionsRequestSchema;
    output: typeof GetSpeechVoiceFilterOptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 7);

/**
 * @generated from service creativefabrica.studiomediamatrix.v1.BrandedMediaService
 */
export const BrandedMediaService: GenService<{
  /**
   * @generated from rpc creativefabrica.studiomediamatrix.v1.BrandedMediaService.DownloadBrandedMedia
   */
  downloadBrandedMedia: {
    methodKind: "unary";
    input: typeof DownloadBrandedMediaRequestSchema;
    output: typeof DownloadBrandedMediaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studiomediamatrix_v1_service, 8);

